import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Enter New Application"),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-gray-500" }, " Wisconsin Statutes 101.63,73 "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-sm" }, " The Information you provide may be used by other government agency programs. [(Privacy Law, S. 15.04 (l)(m))] ")
], -1)
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "col-span-1 lg:col-span-2 font-bold" }, " Submitter Information ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-900 text-sm col-span-1 lg:col-span-2" }, " Your email will only be used for communication regarding the permit appplication and also to allow retrieval of the application by you at a later date. ", -1)
const _hoisted_6 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2 pt-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "col-span-1 lg:col-span-2 font-bold" }, " Owner Information ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block lg:col-span-1" }, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "grid grid-cols-1 gap-2 col-span-1"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block lg:col-span-1" }, null, -1)
const _hoisted_12 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2 pt-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "col-span-1 lg:col-span-2 font-bold" }, " Project Location ", -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "grid grid-cols-1 gap-2 col-span-1"
}
const _hoisted_16 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2 pt-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { class: "col-span-1 lg:col-span-2 font-bold" }, " Permit Information ", -1)
const _hoisted_18 = {
  key: 0,
  class: "grid grid-cols-1 gap-2 col-span-1"
}
const _hoisted_19 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2 pt-4" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<h2 class=\"col-span-1 lg:col-span-2 font-bold\"> Contractor Information </h2><p class=\"text-gray-900 font-bold col-span-1 lg:col-span-2\"> You must enter at least one contractor to submit an application. </p><p class=\"text-gray-900 font-bold col-span-1 lg:col-span-2\"> If you are performing renovations yourself, please select the checkbox in the appropriate section. </p><p class=\"text-gray-900 col-span-1 lg:col-span-2\"> If your search did not return results, <span class=\"font-bold\">PLEASE ADD YOUR CONTRACTOR</span>. You may need to <span class=\"font-bold\">contact your contractor directly</span> for their State of WI license number. This license number can then be used for the search. </p><p class=\"text-gray-900 font-bold col-span-1 lg:col-span-2\"> You can use also use the <a class=\"link text-blue-500\" href=\"https://license.wi.gov/s/license-lookup\" target=\"_blank\">State of Wisconsin Contractor Public Look-up by clicking here</a> to find your contractor&#39;s information. </p>", 5)
const _hoisted_25 = { class: "space-y-4 col-span-1" }
const _hoisted_26 = { class: "border border-gray-200 rounded-md p-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, " Dwelling Contractor ", -1)
const _hoisted_28 = {
  key: 1,
  class: "flex items-start justify-start gap-2"
}
const _hoisted_29 = { class: "w-full" }
const _hoisted_30 = { class: "flex items-center justify-start gap-1" }
const _hoisted_31 = { class: "font-semibold" }
const _hoisted_32 = { class: "text-gray-700 text-sm" }
const _hoisted_33 = { class: "mt-3 pt-3 border-t border-200" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, " Dwelling Qualifier Contractor ", -1)
const _hoisted_35 = {
  key: 1,
  class: "flex items-start justify-start gap-2"
}
const _hoisted_36 = { class: "w-full" }
const _hoisted_37 = { class: "flex items-center justify-start gap-1" }
const _hoisted_38 = { class: "font-semibold" }
const _hoisted_39 = { class: "text-gray-700 text-sm" }
const _hoisted_40 = { class: "border border-gray-200 rounded-md p-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, " Electrical Contractor ", -1)
const _hoisted_42 = {
  key: 1,
  class: "flex items-start justify-start gap-2"
}
const _hoisted_43 = { class: "w-full" }
const _hoisted_44 = { class: "flex items-center justify-start gap-1" }
const _hoisted_45 = { class: "font-semibold" }
const _hoisted_46 = { class: "text-gray-700 text-sm" }
const _hoisted_47 = { class: "mt-3 pt-3 border-t border-200" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, " Master Electrical Contractor ", -1)
const _hoisted_49 = {
  key: 1,
  class: "flex items-start justify-start gap-2"
}
const _hoisted_50 = { class: "w-full" }
const _hoisted_51 = { class: "flex items-center justify-start gap-1" }
const _hoisted_52 = { class: "font-semibold" }
const _hoisted_53 = { class: "text-gray-700 text-sm" }
const _hoisted_54 = { class: "border border-gray-200 rounded-md p-4" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, " HVAC Contractor ", -1)
const _hoisted_56 = {
  key: 1,
  class: "flex items-start justify-start gap-2"
}
const _hoisted_57 = { class: "w-full" }
const _hoisted_58 = { class: "flex items-center justify-start gap-" }
const _hoisted_59 = { class: "font-semibold" }
const _hoisted_60 = { class: "text-gray-700 text-sm" }
const _hoisted_61 = { class: "border border-gray-200 rounded-md p-4" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, " Plumbing Contractor ", -1)
const _hoisted_63 = {
  key: 1,
  class: "flex items-start justify-start gap-2"
}
const _hoisted_64 = { class: "w-full" }
const _hoisted_65 = { class: "flex items-center justify-start gap-1" }
const _hoisted_66 = { class: "font-semibold" }
const _hoisted_67 = { class: "text-gray-700 text-sm" }
const _hoisted_68 = { class: "flex flex-col items-end justify-items-end col-span-1" }
const _hoisted_69 = { class: "flex justify-center w-full" }
const _hoisted_70 = {
  key: 0,
  class: "space-y-5"
}
const _hoisted_71 = { class: "grid grid-col-1 lg:grid-cols-2 gap-4" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 top-[2px] px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)] text-base/6 text-zinc-500 sm:text-sm/6" }, [
  /*#__PURE__*/_createTextVNode(" ft"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_73 = { class: "grid grid-col-2 lg:grid-cols-4 gap-4 pt-4" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h2", { class: "col-span-2 lg:col-span-4 font-bold" }, " Set Backs ", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 top-[2px] px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)] text-base/6 text-zinc-500 sm:text-sm/6" }, [
  /*#__PURE__*/_createTextVNode(" ft"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 top-[2px] px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)] text-base/6 text-zinc-500 sm:text-sm/6" }, [
  /*#__PURE__*/_createTextVNode(" ft"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 top-[2px] px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)] text-base/6 text-zinc-500 sm:text-sm/6" }, [
  /*#__PURE__*/_createTextVNode(" ft"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 top-[2px] px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)] text-base/6 text-zinc-500 sm:text-sm/6" }, [
  /*#__PURE__*/_createTextVNode(" ft"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_79 = { class: "grid grid-col-1 lg:grid-cols-2 gap-4 pt-4" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("h2", { class: "col-span-1 lg:col-span-2 font-bold" }, " Other Information ", -1)
const _hoisted_81 = { class: "grid grid-col-1 lg:grid-cols-2 gap-4 pt-4" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("h2", { class: "col-span-1 lg:col-span-2 font-bold" }, " Area Involved ", -1)
const _hoisted_83 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-4 col-span-1 lg:col-span-2" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 top-[2px] px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)] text-base/6 text-zinc-500 sm:text-sm/6" }, [
  /*#__PURE__*/_createTextVNode(" ft"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 top-[2px] px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)] text-base/6 text-zinc-500 sm:text-sm/6" }, [
  /*#__PURE__*/_createTextVNode(" ft"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 top-[2px] px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)] text-base/6 text-zinc-500 sm:text-sm/6" }, [
  /*#__PURE__*/_createTextVNode(" ft"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 top-[2px] px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)] text-base/6 text-zinc-500 sm:text-sm/6" }, [
  /*#__PURE__*/_createTextVNode(" ft"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_88 = { class: "grid grid-cols-1 gap-4 col-span-1 lg:col-span-2" }
const _hoisted_89 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_90 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_91 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_92 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 top-[1px] px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)] text-base/6 text-zinc-500 sm:text-sm/6" }, " Amps ", -1)
const _hoisted_94 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_95 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_96 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_97 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_98 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_99 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_100 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_101 = { class: "grid grid-col-1 lg:grid-cols-2 gap-4 pt-4" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("h2", { class: "col-span-1 lg:col-span-2 font-bold" }, " Energy Source ", -1)
const _hoisted_103 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_104 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_105 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:col-span-2" }
const _hoisted_106 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2 pt-4" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("h2", { class: "col-span-1 lg:col-span-2 font-bold" }, " Files & Documents ", -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-900 text-base col-span-1 lg:col-span-2" }, " Please upload any files and documents related to this project. Click the button below or drag and drop files to upload. ", -1)
const _hoisted_109 = { class: "col-span-1" }
const _hoisted_110 = { class: "p-2 mx-auto" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 block text-sm font-medium text-gray-900" }, " Drop file here or click to choose ", -1)
const _hoisted_112 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2 pt-4" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("h2", { class: "col-span-1 lg:col-span-2 font-bold" }, " Applicants Signature ", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-900 text-sm col-span-1 lg:col-span-2" }, " I understand that I am subject to all applicable codes, statues and ordinances and with the conditions of this permit; understand the the issuance of the permit creates no legal liability, express or implied, on the state or municipality; and certify that all the above information is accurate. If one acre or more of soil will be disturbed, I understand that this project is subject to CHP NR 151 regarding additional erosion control and storm watermanagement and the owner shall sign the statement on the back of the permit if not signing below. I expressly grant the building inspector, or the inespector's authorizeed agent, permission to enter the premises for which this permit is sought at all reasonable hours and for any proper purpose to inspect the work which is being done. ", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto sm:mx-0 grid grid-cols-1 gap-2 lg:grid-cols-2 col-span-1 lg:col-span-2" }, [
  /*#__PURE__*/_createElementVNode("canvas", {
    id: "signature-pad",
    height: "200",
    width: "325",
    class: "border border-gray-300 shadow-sm rounded space-y-2"
  })
], -1)
const _hoisted_116 = { class: "grid grid-cols-1 gap-2 lg:grid-cols-2 col-span-1" }
const _hoisted_117 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2 pt-4" }
const _hoisted_118 = /*#__PURE__*/_createStaticVNode("<p class=\"text-gray-900 text-base font-bold col-span-2\"> Please Note: </p><p class=\"text-gray-900 text-base font-bold col-span-2\"> All inspections must be requested on <a href=\"www.JIPortal.com\">www.JIPortal.com</a> once the permit fees have been paid. For questions, pelase contact <a href=\"mailto:johnsoninspectiondatabase@gmail.com\">johnsoninspectiondatabase@gmail.com</a>. </p><p class=\"text-red-600 text-base font-bold col-span-2\"> If you don&#39;t receive an application confirmation email, please check your spam or junk folders. </p>", 3)
const _hoisted_121 = { class: "col-span-2 flex flex-wrap-reverse sm:flex-wrap justify-end items-center gap-4 mt-6 w-full" }
const _hoisted_122 = { class: "flex flex-col items-start" }
const _hoisted_123 = ["onSubmit"]
const _hoisted_124 = { class: "space-y-4" }
const _hoisted_125 = { class: "mt-8 space-y-4" }
const _hoisted_126 = { class: "text-gray-500 space-y-2 my-4" }
const _hoisted_127 = { class: "flex items-center justify-start gap-4 mt-6" }

import api from '@/utilities/api'
	import axios from 'axios'
	import SignaturePad from 'signature_pad'
	import contractorPopover from '@/modules/application/components/ContractorPopover.vue'

	import { // icons
		MagnifyingGlassIcon,
		CloudArrowDownIcon,
		TrashIcon
	} from '@heroicons/vue/20/solid'

	import {
		DocumentArrowUpIcon
	} from '@heroicons/vue/24/outline'

	import { // router
		useRoute,
		useRouter,
		onBeforeRouteLeave
	} from 'vue-router'

	import { // types
		Application,
		Address,
		Contractor,
		Permit_File
	} from '@/types'

	import { // vue
		onMounted,
		ref,
		computed,
		onUnmounted,
		nextTick
	} from 'vue'

	interface permitListObject {
		options : any,
		title : String,
		field : any
	}

	
	const __default__ = { name: 'ApplicationForm' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const router = useRouter()

	const googleOwnerMailAddress = ref({})
	const googleProjectSiteAddress = ref({})

	function exitAddressSearch(field: string) {
		if(field === 'owner' && !application.value.ownerMailAddress) {
			application.value.ownerMailAddressSearchString = ""
		}
		else if(field === 'site' && !application.value.siteMailAddress) {
			application.value.siteMailAddressSearchString = ""
		}
		
	}
	
	function setOwnerMailingAddress(gmapsAddress: Address) {
		application.value.ownerMailAddressSearchString = gmapsAddress.searchString
		application.value.ownerMailAddress = gmapsAddress.address1
		application.value.ownerMailAddress2 = gmapsAddress.address2
		application.value.ownerMailCity = gmapsAddress.city
		application.value.ownerMailState = gmapsAddress.state
		application.value.ownerMailZip = gmapsAddress.zipcode
	}
	function setSiteMailingAddress(gmapsAddress: Address) {
		application.value.siteMailAddressSearchString = gmapsAddress.searchString
		application.value.siteMailAddress = gmapsAddress.address1
		application.value.siteMailAddress2 = gmapsAddress.address2
		application.value.siteMailCity = gmapsAddress.city
		application.value.siteMailState = gmapsAddress.state
		application.value.siteMailZip = gmapsAddress.zipcode
	}

	const application = ref<Application>({
		areaBasement: "",
		areaGarage: "",
		areaLiving: "",
		areaOther: "",
		areaTotal: "",
		buildingCost: "",
		constructionType: "",
		contractorDwelling: null,
		contractorDwellingIsOwner: false,
		contractorDwellingSearchString: "",
		contractorDwellingQualifier: null,
		contractorDwellingQualifierIsOwner: false,
		contractorDwellingQualifierSearchString: "",
		contractorElectrical: null,
		contractorElectricalIsOwner: false,
		contractorElectricalSearchString: "",
		contractorElectricalMaster: null,
		contractorElectricalMasterIsOwner: false,
		contractorElectricalMasterSearchString: "",
		contractorHVAC: null,
		contractorHVACIsOwner: false,
		contractorHVACSearchString: "",
		contractorPlumbing: null,
		contractorPlumbingIsOwner: false,
		contractorPlumbingSearchString: "",
		creatorEmail: "",
		creatorEmail2: "",
		creatorNameFirst: "",
		creatorNameLast: "",
		description: "",
		electricalAmps: "",
		electricService: "",
		electricUtility: "",
		energySpace: "",
		energySpaceOther: "",
		energyWater: "",
		energyWaterOther: "",
		files: [],
		heatLostBTU: "",
		hvacs : [],
		hvacsOther: "",
		id: "",
		isAcreSoilDisturbed: false,
		isEnterOwnerAddressManually: false,
		isEnterProjectAddressManually: false,
		ownerIsSameAsSubmitter: false,
		isShowAllApplicationFields: false,
		lotArea: "",
		municipality: "",
		occupancy: "",
		occupancyOther: "",
		ownerEmail: "",
		ownerMailAddressSearchString: "",
		ownerMailAddress: "",
		ownerMailAddress2: "",
		ownerMailCity: "",
		ownerMailCountry: "",
		ownerMailState: "",
		ownerMailZip: "",
		ownerNameFirst: "",
		ownerNameLast: "",
		ownerTelephone: "",
		permitType: [],
		permitTypeOther: "",
		projectType: "",
		projectTypeOther: "",
		setBackFront: "",
		setBackLeft: "",
		setBackRear: "",
		setBackRight: "",
		sewer : "",
		sewerSanitaryPermitNo: "",
		signatureComplete: false,
		signaturePad: "",
		siteBlockNumber: "",
		siteLotNumber: "",
		siteMailAddressSearchString: "",
		siteMailAddress: "",
		siteMailAddress2: "",
		siteMailCity: "",
		siteMailCountry: "",
		siteMailState: "",
		siteMailZip: "",
		siteSubdivision: "",
		story: "",
		storyOther: "",
		use: "",
		useOther: "",
		wall: "",
		wallOther: "",
		water : "",
		zoningDistrict: "",
		zoningPermitNumber: "",
	})

	const permitRequestedSubPermits = ref<{[k: string]: string[]}>({
		permitRequestedConstructionSubOptions : [],
		permitRequestedHVACSubOptions : [],
		permitRequestedElectricSubOptions : [],
		permitRequestedPlumbingSubOptions : [],
		permitRequestedErosionSubOptions : []
	})

	const permitRequestedOtherSubOptions = ref<string>("")

	// #region value lists
	const permitRequestedTypeList = ref([
		{'value': 'Construction' , 'label': 'Construction' },
		{'value': 'HVAC' , 'label': 'HVAC' },
		{'value': 'Electric' , 'label': 'Electric' },
		{'value': 'Plumbing' , 'label': 'Plumbing' },
		{'value': 'Erosion Control' , 'label': 'Erosion Control' },
		{'value': 'Other:' , 'label': 'Other' }
	])
	const projectTypeList = ref([
		{'value': 'New' , 'label': 'New' },
		{'value': 'Alteration' , 'label': 'Alteration' },
		{'value': 'Addition' , 'label': 'Addition' },
		{'value': 'Repair' , 'label': 'Repair' },
		{'value': 'Raze' , 'label': 'Raze' },
		{'value': 'Move' , 'label': 'Move' },
		{'value': 'Other:' , 'label': 'Other' }
	])
	const occupancyTypeList = ref([
		{'value': 'Single Family' , 'label': 'Single Family' },
		{'value': 'Two Family' , 'label': 'Two Family' },
		{'value': 'Commercial' , 'label': 'Commercial' },
		{'value': 'Garage' , 'label': 'Garage' },
		{'value': 'Other:' , 'label': 'Other' }
	])
	const constructionTypeList = ref([
		{'value': 'Site-Built' , 'label': 'Site-Built' },
		{'value': 'Manufactured' , 'label': 'Manufactured' },
		{'value': 'WI UDC' , 'label': 'WI UDC' },
		{'value': 'US HUD' , 'label': 'US HUD' }
	])
	const storyTypeList = ref([
		{'value': '1-Story' , 'label': '1-Story' },
		{'value': '2-Story' , 'label': '2-Story' },
		{'value': 'Plus Basement' , 'label': 'Plus Basement' },
		{'value': 'Other:' , 'label': 'Other' }
	])
	const electricServiceTypeList = ref([
		{'value': 'Underground' , 'label': 'Underground' },
		{'value': 'Overhead' , 'label': 'Overhead' }
	])
	const electricUtilityTypeList = ref([
		{'value': 'Alliant Energy' , 'label': 'Alliant Energy' },
		{'value': 'MGE' , 'label': 'MGE' },
		{'value': 'Mount Horeb Utilities' , 'label': 'Mount Horeb Utilities' },
		{'value': 'Oakdale' , 'label': 'Oakdale' },
		{'value': 'REC' , 'label': 'REC' },
		{'value': 'Richland Center Utilities' , 'label': 'Richland Center Utilities' },
		{'value': 'Vanguard' , 'label': 'Vanguard' }
	])
	const wallTypeList = ref([
		{'value': 'Wood Frame' , 'label': 'Wood Frame' },
		{'value': 'Timber/Pole' , 'label': 'Timber/Pole' },
		{'value': 'Steel' , 'label': 'Steel' },
		{'value': 'ICF' , 'label': 'ICF' },
		{'value': 'Other:' , 'label': 'Other' }
	])
	const HVACEquipmentList = ref([
		{'value': 'Forced Air Furnace' , 'label': 'Forced Air Furnace' },
		{'value': 'Radiant Baseboard/Panel' , 'label': 'Radiant Baseboard/Panel' },
		{'value': 'Heat Pump' , 'label': 'Heat Pump' },
		{'value': 'Boiler' , 'label': 'Boiler' },
		{'value': 'Central Air' , 'label': 'Central Air' },
		{'value': 'Fireplace' , 'label': 'Fireplace' },
		{'value': 'Other:' , 'label': 'Other' }
	])
	const useTypeList = ref([
		{'value': 'Seasonal' , 'label': 'Seasonal' },
		{'value': 'Permanent' , 'label': 'Permanent' },
		{'value': 'Other:' , 'label': 'Other' }
	])
	const sewerTypeList = ref([
		{'value': 'Municipal' , 'label': 'Municipal' },
		{'value': 'Sanitary' , 'label': 'Sanitary' }
	])
	const waterTypeList = ref([
		{'value': 'Municipal Utility' , 'label': 'Municipal Utility' },
		{'value': 'Private On-Site Well' , 'label': 'Private On-Site Well' }
	])
	const municipalityList = ref([
		{ 'value': 'mun_48DB3B0F-7C51-4FAA-9A48-1D895B0AE80B', 'label': 'Arena - Town' },
		{ 'value': 'mun_1A1A2063-1E5F-4B2A-9BE3-C9C63BE24E4F', 'label': 'Arena - Village' },
		{ 'value': 'mun_2F3A8F16-06BD-46D8-AF55-6F45F9FDE92A', 'label': 'Black Earth - Town' },
		{ 'value': 'mun_ABCCDAE3-1222-482C-9FF7-DC6D58109F68', 'label': 'Black Earth - Village' },
		{ 'value': 'mun_617106CF-E99D-48F9-A3C4-66F7D7E71FBC', 'label': 'Cross Plains - Town' },
		{ 'value': 'mun_77E74F75-EDC2-450C-9C80-15FB2B7184AD', 'label': 'Cross Plains - Village' },
		{ 'value': 'mun_B1717A63-C758-4834-98E5-D254E07020DA', 'label': 'Mazomanie - Town' },
		{ 'value': 'mun_9C4DCCC8-7F33-4240-A385-65352ED25CB6', 'label': 'Mazomanie - Village' },
		{ 'value': 'mun_4015A017-2FCB-409D-BD3E-E8F5AFBA1D58', 'label': 'Middleton - Town' },
		{ 'value': 'mun_7C212124-2D36-4BCD-AE14-84527B23EE41', 'label': 'Prairie du Sac - Town' },
		{ 'value': 'mun_5899010D-16D5-4F86-85BC-1734303EC4B4', 'label': 'Richland Center - City' },
		{ 'value': 'mun_F8F64AB7-DE0E-4B5A-A05B-DF9C15D5DC4A', 'label': 'Richland Center - Town' },
		{ 'value': 'mun_6748921D-6B0B-4631-9D6B-981F4A6D7B16', 'label': 'Spring Green - Town' },
		{ 'value': 'mun_4CF3D9C2-190F-4D1F-A611-E62BCEB15770', 'label': 'Sumpter - Town' },
		{ 'value': 'mun_948E97F5-FB16-491C-A6FA-5C6DE0C2DCE5', 'label': 'Vermont - Town' }
	])
	const energySpaceTypeList = ref([
		{'value': 'Natural Gas' , 'label': 'Natural Gas' },
		{'value': 'LP' , 'label': 'LP' },
		{'value': 'Oil' , 'label': 'Oil' },
		{'value': 'Electricity' , 'label': 'Electricity' },
		{'value': 'Solid' , 'label': 'Solid' },
		{'value': 'Solar' , 'label': 'Solar' },
		{'value': 'Other:' , 'label': 'Other' }
	])
	const waterHeatingTypeList = ref([
		{'value': 'Natural Gas' , 'label': 'Natural Gas' },
		{'value': 'LP' , 'label': 'LP' },
		{'value': 'Oil' , 'label': 'Oil' },
		{'value': 'Electricity' , 'label': 'Electricity' },
		{'value': 'Solid' , 'label': 'Solid' },
		{'value': 'Solar' , 'label': 'Solar' },
		{'value': 'Other:' , 'label': 'Other' }
	])
	const permitRequestedConstructionSubList = ref([
		{'value': 'New Commercial Building' , 'label': 'New Commercial Building' },
		{'value': 'New Single-Family Dwelling' , 'label': 'New Single-Family Dwelling' },
		{'value': 'Two Family Duplex' , 'label': 'Two Family Duplex' },
		{'value': 'Commercial Remodel' , 'label': 'Commercial Remodel' },
		{'value': 'Residential Basement Remodel' , 'label': 'Redidential Basement Remodel' },
		{'value': 'Residential Bath Remodel' , 'label': 'Residential Bath Remodel' },
		{'value': 'Residential Kitchen Remodel' , 'label': 'Residential Kitchen Remodel' },
		{'value': 'Commercial Addition' , 'label': 'Commercial Addition' },
		{'value': 'Residential Addition' , 'label': 'Residential Addition' },
		{'value': 'Commercial Re-Roof' , 'label': 'Commercial Re-Roof' },
		{'value': 'Fence' , 'label': 'Fence' },
		{'value': 'Residential Re-Roof' , 'label': 'Residential Re-Roof' },
		{'value': 'Sign' , 'label': 'Sign' },
		{'value': 'Swimming Pool' , 'label': 'Swimming Pool' },
		{'value': 'Agricultural Building' , 'label': 'Agricultural Building' },
		{'value': 'Mobile Home' , 'label': 'Mobile Home' },
		{'value': 'Residential Accessory Structure' , 'label': 'Residential Accessory Structure' },
		{'value': 'Shed' , 'label': 'Shed' },
		{'value': 'Garage' , 'label': 'Garage' },
		{'value': 'Deck' , 'label': 'Deck' },
	])
	const permitRequestedHVACSubList = ref([
		{'value': 'Furnace & A/C Replacement' , 'label': 'Furnace & A/C Replacement' },
		{'value': 'Water Heater Replacement' , 'label': 'Water Heater Replacement' },
		{'value': 'Water Softener Replacement' , 'label': 'Water Softener Replacement' },
		{'value': 'New Single-Family Dwelling HVAC' , 'label': 'New Single-Family Dwelling HVAC' },
	])
	const permitRequestedElectricSubList = ref([
		{'value': 'Commercial Electrical Service Upgrade ' , 'label': 'Commercial Electrical Service Upgrade ' },
		{'value': 'EV Charger' , 'label': 'EV Charger' },
		{'value': 'Residential Electrical Service Upgrade ' , 'label': 'Residential Electrical Service Upgrade ' },
		{'value': 'Residential Generator' , 'label': 'Residential Generator' },
		{'value': 'Solar-Photaic Roof Top System' , 'label': 'Solar-Photaic Roof Top System' },
		{'value': 'New Single-Family Dwelling Electrical' , 'label': 'New Single-Family Dwelling Electrical' },
	])
	const permitRequestedPlumbingSubList = ref([
		{'value': 'Water Heater Replacement' , 'label': 'Water Heater Replacement' },
		{'value': 'Water Softener Replacement' , 'label': 'Water Softener Replacement' },
		{'value': 'New Single-Family Dwelling Plumbing' , 'label': 'New Single-Family Dwelling Plumbing' },
	])
	const permitRequestedErosionSubList = ref([
		{'value': 'Construction' , 'label': 'Construction' },
		{'value': 'HVAC' , 'label': 'HVAC' },
		{'value': 'Electric' , 'label': 'Electric' },
		{'value': 'Plumbing' , 'label': 'Plumbing' },
		{'value': 'Erosion Control' , 'label': 'Erosion Control' },
		{'value': 'Other:' , 'label': 'Other' }
	])
	// #endregion
	
	const permitSubTypeContainsOther = computed<boolean>(()=> {
		let exists = false
		let permitList = application.value.permitType as []
		for(let permit in (permitList)){
			if(permitList[permit] == 'Other:'){
				exists = true
			}
		}
		return exists
	})

	const permitSubTypeList = computed<permitListObject[]>(()=> getSubPermitList())

	const isOwnerDisabled = computed(() => {
		return permitRequestedSubPermits.value?.permitRequestedConstructionSubOptions?.includes('New Single-Family Dwelling') ||
			permitRequestedSubPermits.value?.permitRequestedConstructionSubOptions?.includes('New Commercial Building') ||
			permitRequestedSubPermits.value?.permitRequestedConstructionSubOptions?.includes('Two Family Duplex')
	})

	const isNewConstruction = computed(() => {
		return permitRequestedSubPermits.value?.permitRequestedConstructionSubOptions?.includes('New Single-Family Dwelling') ||
			permitRequestedSubPermits.value?.permitRequestedConstructionSubOptions?.includes('Two Family Duplex')
	})

	async function updateSelectedContractors() {
		
		if(isOwnerDisabled.value) {
			if(application.value.contractorElectricalMasterIsOwner) clearContractor('electrical')
			if(application.value.contractorElectricalIsOwner) clearContractor('masterElectrician')
			if(application.value.contractorHVACIsOwner) clearContractor('plumbing')
			if(application.value.contractorPlumbingIsOwner) clearContractor('hvac')
		}

		if(isNewConstruction.value) {
			application.value.isShowAllApplicationFields = true
		}
		return
	}
	
	function getSubPermitList() {
		let savedOptionSelections : {[k: string]: string[]} = {
			permitRequestedConstructionSubOptions : [],
			permitRequestedHVACSubOptions : [],
			permitRequestedElectricSubOptions : [],
			permitRequestedPlumbingSubOptions : [],
			permitRequestedErosionSubOptions : []
		}

		let subItemList = [] as permitListObject[]
		let permitList = application.value.permitType as []
		
		for(let permit in (permitList)){
			if(permitList[permit] == 'Construction'){
				subItemList.push({
					'options' : permitRequestedConstructionSubList.value,
					'title' : permitList[permit],
					'field' : 'permitRequestedConstructionSubOptions'
				})	
				savedOptionSelections['permitRequestedConstructionSubOptions'] = permitRequestedSubPermits.value['permitRequestedConstructionSubOptions']
			}
			else if(permitList[permit] =='HVAC'){
				subItemList.push({
					options : permitRequestedHVACSubList.value,
					title : permitList[permit],
					field : 'permitRequestedHVACSubOptions'
				})
				savedOptionSelections['permitRequestedHVACSubOptions'] = permitRequestedSubPermits.value['permitRequestedHVACSubOptions']
			}
			else if(permitList[permit] =='Electric'){
				subItemList.push({
					'options' : permitRequestedElectricSubList.value,
					'title' : permitList[permit],
					'field' : 'permitRequestedElectricSubOptions'
				})	
				savedOptionSelections['permitRequestedElectricSubOptions'] = permitRequestedSubPermits.value['permitRequestedElectricSubOptions']
			}
			else if(permitList[permit] =='Plumbing'){
				subItemList.push({
					'options' : permitRequestedPlumbingSubList.value,
					'title' : permitList[permit],
					'field' : 'permitRequestedPlumbingSubOptions'
				})	
				savedOptionSelections['permitRequestedPlumbingSubOptions'] = permitRequestedSubPermits.value['permitRequestedPlumbingSubOptions']
			}
			else if(permitList[permit] =='Erosion Control'){
				subItemList.push({
					'options' : permitRequestedErosionSubList.value,
					'title' : permitList[permit],
					'field' : 'permitRequestedErosionSubOptions'
				})	
				savedOptionSelections['permitRequestedErosionSubOptions'] = permitRequestedSubPermits.value['permitRequestedErosionSubOptions']
			}
		}
		permitRequestedSubPermits.value = savedOptionSelections
		return subItemList
	}

	onBeforeRouteLeave((to, from, next) => {
		if(submitting.value){
			next()
		}
		else{
			const answer = window.confirm(
				'You have not yet submitted your application. You will lose all progress if you exit.'
			)
			// cancel the navigation and stay on the same page
			if (!answer) return false
			next()
		}
	})


	const route = useRoute()
	const applicationLoading = ref(false)

	onMounted(async () => {
		// load draft
		const query = route.query
		const id = query?.id || ""
		if(id) {
			try { // loading list of permits 
				applicationLoading.value = true
				let payload = {
					id: id
				}
		
				const body = {
					action: "getApplication",
					payload: payload,
				}
		
				const response = await api("post", "fmDataApi", "/fm-data-api", body)

				const scriptResult = JSON.parse(response?.response?.scriptResult ?? "{}")
				application.value = {...scriptResult.result.data.application, files: scriptResult.result.data.files}

				// set contractor objects to null if empty
				if(!Object.keys(application.value.contractorDwelling ?? {}).length) application.value.contractorDwelling = null
				if(!Object.keys(application.value.contractorElectrical ?? {}).length) application.value.contractorElectrical = null
				if(!Object.keys(application.value.contractorHVAC ?? {}).length) application.value.contractorHVAC = null
				if(!Object.keys(application.value.contractorPlumbing ?? {}).length) application.value.contractorPlumbing = null

				// set contractor is owner if matching ID
				if(application.value?.contractorDwelling?.id === process.env.VUE_APP_OWNER_CTR_ID) application.value.contractorDwellingIsOwner = true
				if(application.value?.contractorElectrical?.id === process.env.VUE_APP_OWNER_CTR_ID) application.value.contractorElectricalIsOwner = true
				if(application.value?.contractorHVAC?.id === process.env.VUE_APP_OWNER_CTR_ID) application.value.contractorHVACIsOwner = true
				if(application.value?.contractorPlumbing?.id === process.env.VUE_APP_OWNER_CTR_ID) application.value.contractorPlumbingIsOwner = true

				// build address search strings
				application.value.siteMailAddressSearchString = [
					[application.value.siteMailAddress, application.value.siteMailAddress2, application.value.siteMailCity].filter(Boolean).join(" "), 
					[application.value.siteMailState, application.value.siteMailZip].filter(Boolean).join(" ")
				].filter(Boolean).join(", ")

				application.value.ownerMailAddressSearchString = [
					[application.value.ownerMailAddress, application.value.ownerMailAddress2, application.value.ownerMailCity].filter(Boolean).join(" "), 
					[application.value.ownerMailState, application.value.ownerMailZip].filter(Boolean).join(" ")
				].filter(Boolean).join(", ")

				// set checkboxes to be boolean
				// is "0" or "1" from FM
				// the loose equailty allows valid comparison beetween the bool typed `Application` interface and string typed FM field
				application.value.isAcreSoilDisturbed = application.value.isAcreSoilDisturbed == false ? false : true
				application.value.ownerIsSameAsSubmitter = application.value.ownerIsSameAsSubmitter == false ? false : true
				application.value.isShowAllApplicationFields = application.value.isShowAllApplicationFields == false ? false : true

				// shape municipality
				if(application.value?.municipality?.id) {
					application.value.municipality = application.value.municipality.id
				}

			}
			catch(e) {
				console.log(e)
			}
			finally {
				applicationLoading.value = false
			}
		}

		application.value.signaturePad = new SignaturePad(document.getElementById('signature-pad') as HTMLCanvasElement) ?? {} as HTMLCanvasElement
		application.value.signaturePad?.addEventListener("endStroke", () => {
			application.value.signatureComplete = true
		})

		// add drag and drop event listeners
		drop.value?.addEventListener("dragover", () => {
			isOver.value = true
		})
		drop.value?.addEventListener("drop", (e) => {
			isOver.value = false
			fileUpload(e)
		})
		drop.value?.addEventListener("dragleave", () => {
			isOver.value = false
		})
	})

	onUnmounted(() => {
		// add drag and drop event listeners
		drop.value?.removeEventListener("dragover", () => {
			isOver.value = true
		})
		drop.value?.removeEventListener("drop", (e) => {
			isOver.value = false
			fileUpload(e)
		})
		drop.value?.removeEventListener("dragleave", () => {
			isOver.value = false
		})
	})

	// #region signature
	function encodeSignature() {
		let encodedSignature
		try{
			if(!application.value.signaturePad || !application.value.signatureComplete){
				throw ("There is no signature entered.")
			}
			else{
				encodedSignature = application.value.signaturePad.toDataURL()
			}
			return encodedSignature
		}
		catch(e){
			let title= "Missing Required Information"
			let subtitle = "Please enter a valid signature."
			displayNotification(title, subtitle)
			submitting.value = false
			throw "Invalid signature"
		}
	}

	function clearSignature() {
		application.value.signaturePad?.clear()
		application.value.signatureComplete = false
	}
	// #endregion

	// #region submit form
	const submitting = ref(false)
	const municipalityListbox = ref<{validate: Function} | null>(null)
	const permitsRequestedListbox = ref<{validate: Function} | null>(null)

	async function submitApplication(){
		submitting.value = true
		let encodedSignature = encodeSignature()

		if(validate()){
			let payload = {
				application : {
					...application.value,
					permitRequestedSubPermits: permitRequestedSubPermits.value,
				},
				signature : encodedSignature,
				options : {
					type : 'Submit'
				}
			}

			const body = {
				action: "submitApplication",
				payload: payload
			}
			try{
				let response = await api("post", "fmDataApi", "/fm-data-api", body)
				response = response.response

				let scriptOutput = JSON.parse(response.scriptResult)
				if(scriptOutput.error){
					console.log(scriptOutput.error)
					throw scriptOutput.error
				}
				router.push({name:'ApplicationList' , query: {id: scriptOutput.personQueryID, type: "p"}})
			}
			catch(e) {
				displayNotification("Submit Error" , "There was an error submitting your application. Please try again later.")
				submitting.value = false
			}
		}
		else{
			submitting.value = false
		}
	}

	function validateEmail() {
		//Seperate Check for email confirmation
		let creatorEmail = document.getElementById("your-email") as HTMLInputElement
		let creatorEmailConfirm = document.getElementById("confirm-email") as HTMLInputElement
		if(creatorEmail?.value !== creatorEmailConfirm?.value || !creatorEmail?.value || !creatorEmailConfirm?.value){
			creatorEmail?.setAttribute('data-invalid', 'true' )
			creatorEmailConfirm?.setAttribute('data-invalid', 'true' )
			displayNotification("Submission Error", "Email and Confirmation must be filled in and match.")
			return false
		}
		return true
	}

	function validate() {
		let isValid = true
		let validFieldList = document.querySelectorAll('#form [required]')

		try{
			validFieldList.forEach(field => {
				if(!field.value && field.value !== 0 && field.value !== "0"){
					field.setAttribute('data-invalid', 'true' )
					isValid = false
				}
				else{
					field.removeAttribute('data-invalid')
				}

			})
			isValid = !isValid ? false : validateEmail()			
		}
		catch(e){
			console.log(e)
		}
	
		if(!municipalityListbox.value?.validate()) {
			isValid = false
		}
		if(!permitsRequestedListbox.value?.validate()) {
			isValid = false
		}

		if(application.value.permitType?.includes('Plumbing') && !application.value.contractorPlumbing) {
			displayNotification("Submission Error" , "Plumbing contractor is required.")
			isValid = false
		}

		else if(!application.value.contractorDwelling &&
			!application.value.contractorElectrical &&
			!application.value.contractorHVAC &&
			!application.value.contractorDwelling) {
			displayNotification("Submission Error" , "Please select at least one contractor or indicate you are performing the renovations.")
			document?.querySelector("[name='dwelling-contractor-search']")?.focus()
			isValid = false
		}

		else if(!isValid){
			displayNotification("Submission Error" , "Please fill in all required fields.")
		}
		

		if(isOwnerDisabled.value && 
			(!application.value.contractorElectrical  &&
				!application.value.contractorHVAC &&
				!application.value.contractorPlumbing &&
				!application.value.contractorElectricalMaster)) {
			displayNotification("Submission Error" , "Electrical, HVAC, and Plumbing contractors are required.")
			isValid = false
		}

		return isValid
	}

	async function saveForLater() {
		submitting.value = true
		if(validateEmail()){		
			let payload = {
				application : application.value,
				options : {
					type : 'SaveAsDraft'
				}
			}
			const body = {
				action: "submitApplication",
				payload: payload
			}
			try{
				let response = await api("post", "fmDataApi", "/fm-data-api", body)
				response = response.response
				let scriptOutput = JSON.parse(response.scriptResult)
				if(scriptOutput.error) {
					console.log(scriptOutput.error)
					throw scriptOutput.error
				}
				router.push({name:'ApplicationList' , query: {id: scriptOutput.personQueryID, type: "p"}})
			}
			catch(e) {
				displayNotification("Submit Error" , "There was an error saving your application. Please try again later.")
				submitting.value = false
			}
		}
		else{
			submitting.value = false
		}
	}
	// #endregion

	// #region notifcations
	const showNotification = ref<Boolean>(false)
	const notificationTitle = ref<String | null>(null)
	const notificationSubtitle = ref<String | null>(null)
	const notificationType =  ref<number | null>(null)

	function displayNotification(title : string, subtitle : string, type = 1 ){
		notificationTitle.value = title
		notificationSubtitle.value = subtitle
		notificationType.value = type
		showNotification.value = true
	}
	// #endregion

	// #region contractor search
	const contractorSearchTitle = ref<string | null>()
	const contractorSearchResults = ref<[]>([])
	const contractorSearchType = ref<string | null>()
	const contractorLoading = ref<boolean | null>(null)
	const contractorMissingText = ref<string>("No Contractors found.")
	const contractorTable = ref<{flipPage : any } | null>(null)

	/**
	* Grabs the contractors from a find in FileMaker
	* @param {string} type - The type of contractor we are searching for
	* @param {string} searchCriteria - The string being used in the search - Is sanitized in FM
	*/
	async function contractorSearch( type: string , searchCriteria: string){
		if(!searchCriteria.length) return
		var searchTitle = ''
		switch(type){
			case 'general':{
				searchTitle = 'Dwelling'
				break
			}
			case 'electrical':{
				searchTitle = 'Electrical'
				break
			}
			case 'hvac':{
				searchTitle = 'HVAC'
				break
			}
			case 'plumbing':{
				searchTitle = 'Plumbing'
				break
			}
			case 'qualifier':{
				searchTitle = 'General Qualifier'
				break
			}
			case 'masterElectrician':{
				searchTitle = 'Master Electrician'
				break
			}
		}
		contractorSearchTitle.value = searchTitle
		contractorSearchResults.value.length = 0
		contractorLoading.value = true
		let payload = {
			'searchCriteria' : searchCriteria,
			'type' : type
		}

		const body = {
			action: "contractorSearch",
			payload: payload,
			
		}
		try{
			const response = await api("post", "fmDataApi", "/fm-data-api", body)
			parseContractorData(response)
			type = (type == "general") ? "dwelling" : type
			contractorSearchType.value = type
			contractorMissingText.value = "No Contractors found for \x22" + searchCriteria + "\x22"
			contractorTable.value?.flipPage(1)
		}
		catch(e){
			displayNotification("Search Error" , "There was an error searching contractors. Please try again later.")
		}
		finally{
			contractorLoading.value = false
		}
	}

	/**
	* Parses the JSON receieved from FM
	* @param {any} response - The JSON response received from FM
	*/
	function parseContractorData( response: any ) {
		response = response.response
		let values = JSON.parse(response.scriptResult)
		contractorSearchResults.value = Object.keys(values).length === 0 ? [] : values
	}

	function setIsOwnerContractor(type: string, value: boolean) {
		switch(type) {
			case 'dwelling':{
				application.value.contractorDwelling = value ? {id: process.env.VUE_APP_OWNER_CTR_ID} as Contractor : null
				break
			}
			case 'electrical':{
				application.value.contractorElectrical = value ? {id: process.env.VUE_APP_OWNER_CTR_ID} as Contractor : null
				break
			}
			case 'hvac':{
				application.value.contractorHVAC = value ? {id: process.env.VUE_APP_OWNER_CTR_ID} as Contractor : null
				break
			}
			case 'plumbing':{
				application.value.contractorPlumbing = value ? {id: process.env.VUE_APP_OWNER_CTR_ID} as Contractor : null
				break
			}
			case 'qualifier':{
				application.value.contractorDwellingQualifier = value ? {id: process.env.VUE_APP_OWNER_CTR_ID} as Contractor : null
				break
			}
			case 'masterElectrician':{
				application.value.contractorElectricalMaster = value ? {id: process.env.VUE_APP_OWNER_CTR_ID} as Contractor : null
				break
			}
			default:
				throw "No search type indicated"
		}
	}
	/**
	* Allows user to select a contractor from the table
	* @param {Object} row - The contractor data object from the selected row
	*/
	function selectContractor( row: Contractor) {
		try{
			switch(contractorSearchType.value){
				case 'dwelling':{
					application.value.contractorDwelling = row
					break
				}
				case 'electrical':{
					application.value.contractorElectrical = row
					break
				}
				case 'hvac':{
					application.value.contractorHVAC = row
					break
				}
				case 'plumbing':{
					application.value.contractorPlumbing = row
					break
				}
				case 'qualifier':{
					application.value.contractorDwellingQualifier = row
					break
				}
				case 'masterElectrician':{
					application.value.contractorElectricalMaster = row
					break
				}
				default:
					throw "No search type indicated"
				
			}
		}
		catch(e){
			displayNotification("Selection Error" , "There was an error selecting a contractor. Please try again later.")
		}

		contractorSearchResults.value = []
		contractorSearchTitle.value = null
		contractorSearchType.value = null
	}

	/**
	* Clears the currently selected contractor for a given type
	* @param {string} type - The type of contractor we are clearing
	*/
	function clearContractor( type: string ) {
		type = (type == "general") ? "dwelling" : type
		try{
			switch(type){
				case 'dwelling':{
					application.value.contractorDwelling = null
					application.value.contractorDwellingIsOwner = false
					application.value.contractorDwellingQualifier = null
					application.value.contractorDwellingQualifierIsOwner = false
					break
				}
				case 'electrical':{
					application.value.contractorElectrical = null
					application.value.contractorElectricalIsOwner = false
					application.value.contractorElectricalMaster = null
					application.value.contractorElectricalMasterIsOwner = false
					break
				}
				case 'qualifier':{
					application.value.contractorDwellingQualifier = null
					application.value.contractorDwellingQualifierIsOwner = false
					break
				}
				case 'masterElectrician':{
					application.value.contractorElectricalMaster = null
					application.value.contractorElectricalMasterIsOwner = false
					break
				}
				case 'hvac':{
					application.value.contractorHVAC = null
					application.value.contractorHVACIsOwner = false
					break
				}
				case 'plumbing':{
					application.value.contractorPlumbing = null
					application.value.contractorPlumbingIsOwner = false
					break
				}
				default:
					throw "Missing Type of Contractor to Clear"
				
			}
		}
		catch(e){
			displayNotification("Search Error" , "There was an error clearing the contractor. Please try again later.")
		}

		contractorSearchResults.value = []
		contractorSearchTitle.value = null
		contractorSearchType.value = null
	}
	// #endregion

	// #region add contractor
	const addingContractor = ref<{[k : string] :string }>({
		type : "",
		company : "",
		license : "",
		expiration : "",
		nameFirst : "",
		nameLast : "",
		phone : "",
		email : "",
	})
	const contractorModal =ref<{open: boolean}>({open: false})
	const addingContractorErrorMessage = ref()

	async function addContractor() {
		try{
			if(!validateAddedContractor()){
				return null
			}
			const body = {
				action: 'addContractor',
				payload: {
					contractorInfo: addingContractor.value
				}
			}
			let response = await api("post", "fmDataApi", "/fm-data-api", body)
			response= response.response
			let scriptResult = JSON.parse(response.scriptResult)
			if(!scriptResult){
				throw('Contractor Addition is temporarily unavailable.')
			}
			else if(scriptResult?.error){
				addingContractorErrorMessage.value = scriptResult.error 
			}
			else{
				let contractor = (JSON.parse(response.scriptResult)).contractor
				switch(addingContractor.value.type){
					case 'dwelling':{
						application.value.contractorDwelling = contractor
						break
					}
					case 'electrical':{
						application.value.contractorElectrical = contractor
						break
					}
					case 'hvac':{
						application.value.contractorHVAC = contractor
						break
					}
					case 'plumbing':{
						application.value.contractorPlumbing = contractor
						break
					}
					case 'qualifier':{
						application.value.contractorDwellingQualifier = contractor
						break
					}
					case 'masterElectrician':{
						application.value.contractorElectricalMaster = contractor
						break
					}
					default:
						throw "Missing Type of Contractor to Clear"
				}
				contractorSearchResults.value = []
				contractorSearchTitle.value = null
				contractorSearchType.value = null
				addingContractorErrorMessage.value = null
				clearAddContractorValues()
			}			
		}
		catch(e){
			displayNotification("Adding Contractor Error" , "There was an error adding the contractor. Please try again later.")
			clearAddContractorValues()
		}
	}

	function validateAddedContractor() {
		let isValid = true
		let validFieldList = document.querySelectorAll('#add-contractor-form')[0]
		try{
			for(let i in validFieldList){
				if((validFieldList[i].value == '') && (validFieldList[i].nodeName == 'INPUT')){
					validFieldList[i].setAttribute('data-invalid', 'true' )
					isValid = false
				}
				else if(validFieldList[i].nodeName == 'INPUT'){
					validFieldList[i].removeAttribute('data-invalid')
				}
			}
		}
		catch(e){
			console.log(e)
		}
		if(!isValid){
			addingContractorErrorMessage.value = "Please fill in all contractor information."
		}
		return isValid
	}

	function clearAddContractorValues() {
		addingContractor.value.type = ''
		addingContractor.value.company = ''
		addingContractor.value.license = ''
		addingContractor.value.expiration = ''
		addingContractor.value.nameFirst = ''
		addingContractor.value.nameLast = ''
		addingContractor.value.phone = ''
		addingContractor.value.email = ''
		addingContractorErrorMessage.value = ''
		contractorModal.value.open = false
	}

	function openModal() {
		clearAddContractorValues()
		addingContractor.value.type = contractorSearchType.value ?? ""
		contractorModal.value.open = true
	}
	// #endregion

	// #region file operations
	const documentUploadRef = ref<HTMLInputElement | null>()
	const drop = ref<null | HTMLElement>(null)
	const isOver = ref(false)
	const file = ref<File>({} as File)
	const fileInput = ref<File[]>([])
	const fileUploadingLoading = ref(false)

	/**
    * Validates file type, uploads file to S3 and creates record in FileMaker
    * @function fileUpload
    * @param {Object} e - drop event
    */
	async function fileUpload(e: any){
		try {
			fileUploadingLoading.value = true
			isOver.value = false
			fileInput.value = e.target.files || e.dataTransfer.files
			file.value = file.value = fileInput.value?.['0']
			const re = new RegExp(/^.+\.(jpg|jpeg|gif|png|pdf)$/, 'g')
			const acceptedFileType = re.test(file.value.name.toLowerCase())
			if(!acceptedFileType){
				alert("Unaccepted file type")
				throw("Unaccepted file type")
			}

			// get signed upload url
			let getPayload = {
				type: "application",
				entityId: application.value.id,
				filename: file.value.name,
				size: file.value.size,
				mimeType: file.value.type,
				creatorEmail: application.value.creatorEmail
			}

			const getBody = {
				action: "uploadFile",
				payload: getPayload,
			}

			const getResponse = await api("post", "fmDataApi", "/fm-data-api", getBody)
			const getScriptResult = JSON.parse(getResponse.response.scriptResult)

			// upload file to s3
			const signedUrl = getScriptResult.signedRequest
			const config = {
				method: 'put',
				url: signedUrl,
				data: file.value
			}
			const res = await axios(config)
			
			// mark file as uploaded
			const patchPayload = {
				type: "application",
				fileId: getScriptResult.uuid
			}

			const patchBody = {
				action: "confirmUpload",
				payload: patchPayload,
			}

			const patchResponse = await api("post", "fmDataApi", "/fm-data-api", patchBody)
			const patchScriptResult = JSON.parse(patchResponse.response.scriptResult)
			if(patchScriptResult.success) {
				displayNotification( "Success", "File uploaded complete.", 0)
				application.value.files.push(
					{
						created: getScriptResult.creationTimestamp,
						createdAsNumber: getScriptResult.createdAsNumber,
						fileID: getScriptResult.uuid,
						fileName: file.value.name,
						isAllowedDelete: true
					} as Permit_File
				)
			}
			else {
				displayNotification("Error", "There was an issue uploading your file. Please try again.")
			}

		}
		catch(err) {
			console.log(err)
			displayNotification("Error", "There was an issue uploading your file. Please try again.")
		}
		finally {
			fileUploadingLoading.value = false
		}
	}

	const fileDownloadLoading = ref<boolean[]>([])

	/**
    * Downloads file from S3
    * @function downloadFile
	* @param {Permit_File} file - the file object to download
	* @param {Number} index - the index of the file in the list of files
    */
	async function downloadFile(file: Permit_File) {
		
		let payload = {
			fileId: file.fileID
		}
	
		const body = {
			action: "getSignedUrl",
			payload: payload,
		}
		try {
			//fileDownloadLoading.value[index] = true
			const response = await api("post", "fmDataApi", "/fm-data-api", body)
			const signedUrl = JSON.parse(response.response.scriptResult).downloadURL
	
			const link = document.createElement("a")
			link.href = signedUrl
			link.target = "_blank"
			link.download = file.fileName
			link.click()
		}
		catch(e) {
			console.error(e)
		}
		// finally {
		// 	fileDownloadLoading.value[index] = false
		// }
	}

	const deleteModal = ref<{open: boolean}>({open: false})
	const selectedFile = ref<Permit_File>({} as Permit_File)
	const deleteLoading = ref(false)

	/**
    * Opens delete file confirmation modal
    * @function openDeleteModal
	* @param {Permit_File} file - the file object to delete
    */
	function openDeleteModal(file: Permit_File) {
		selectedFile.value = file
		deleteModal.value.open = true
	}

	/**
    * Closes the delete file confirmation modal and optionally deletes the file from S3 and FileMaker
    * @function closeDeleteModal
	* @param {Boolean} deleteFile - whether or not to delete the selected file when closing the modal
    */
	async function closeDeleteModal(deleteFile: boolean = false) {
		if(deleteFile) {
			const payload = {
				fileId: selectedFile.value.fileID
			}
		
			const body = {
				action: "deleteFile",
				payload: payload
			}

			try {
				deleteLoading.value = true
				const response = await api("post", "fmDataApi", "/fm-data-api", body)
				const scriptResult = JSON.parse(response.response.scriptResult)
				if(scriptResult.success) {
					displayNotification("Success", "File deleted." , 0)
				}
				else {
					displayNotification("Error", "There was an issue deleting your file. Please try again.")
				}

				// find file in array and remove it
				const deletedFileIndex = application.value.files.findIndex((file) => {
					return file.fileID === selectedFile.value.fileID
				})
				application.value.files.splice(deletedFileIndex, 1)
			}
			catch(e) {
				console.error(e)
				displayNotification("Error", "There was an issue deleting your file. Please try again.")
			}
			finally {
				deleteLoading.value = false
			}
		}
		deleteModal.value.open = false

	}
	// #endregion
	

return (_ctx: any,_cache: any) => {
  const _component_tw_full_screen_loading = _resolveComponent("tw-full-screen-loading")!
  const _component_tw_notification = _resolveComponent("tw-notification")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_checkbox_field = _resolveComponent("v-checkbox-field")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_switch_field = _resolveComponent("v-switch-field")!
  const _component_google_maps_autocomplete = _resolveComponent("google-maps-autocomplete")!
  const _component_v_description = _resolveComponent("v-description")!
  const _component_tw_select = _resolveComponent("tw-select")!
  const _component_v_input_group = _resolveComponent("v-input-group")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!
  const _component_tw_loading = _resolveComponent("tw-loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_error_message = _resolveComponent("v-error-message")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_tw_full_screen_loading, null, null, 512), [
      [_vShow, applicationLoading.value]
    ]),
    (showNotification.value)
      ? (_openBlock(), _createBlock(_component_tw_notification, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showNotification.value = false)),
          title: notificationTitle.value ?? 'Notification',
          subtitle: notificationSubtitle.value ?? 'Message',
          icon: notificationType.value
        }, null, 8, ["title", "subtitle", "icon"]))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createElementVNode("form", {
      id: "form",
      class: "py-4 space-y-5",
      onSubmit: _withModifiers(submitApplication, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_v_field, { class: "col-span-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_input, {
              modelValue: application.value.creatorNameFirst,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((application.value.creatorNameFirst) = $event)),
              "aria-label": "First Name",
              placeholder: "First Name",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_field, { class: "col-span-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_input, {
              modelValue: application.value.creatorNameLast,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((application.value.creatorNameLast) = $event)),
              "aria-label": "Last Name",
              placeholder: "Last Name",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_field, { class: "col-span-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_input, {
              modelValue: application.value.creatorEmail,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((application.value.creatorEmail) = $event)),
              id: "your-email",
              "aria-label": "Your Email",
              placeholder: "Your Email",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_field, { class: "col-span-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_input, {
              modelValue: application.value.creatorEmail2,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((application.value.creatorEmail2) = $event)),
              id: "confirm-email",
              "aria-label": "Confirm Email",
              placeholder: "Confirm Email",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_v_checkbox_field, { class: "col-span-1 lg:col-span-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: application.value.ownerIsSameAsSubmitter,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((application.value.ownerIsSameAsSubmitter) = $event)),
              color: "amber"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_label, null, {
              default: _withCtx(() => [
                _createTextVNode("Same as Submitter")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_field, {
          class: "col-span-1",
          disabled: application.value.ownerIsSameAsSubmitter
        }, {
          default: _withCtx(() => [
            (!application.value.ownerIsSameAsSubmitter)
              ? (_openBlock(), _createBlock(_component_v_input, {
                  key: 0,
                  modelValue: application.value.ownerNameFirst,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((application.value.ownerNameFirst) = $event)),
                  "aria-label": "Owner's First Name",
                  placeholder: "Owner's First Name",
                  required: ""
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(_component_v_input, {
                  key: 1,
                  modelValue: application.value.creatorNameFirst,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((application.value.creatorNameFirst) = $event)),
                  "aria-label": "Owner's First Name",
                  placeholder: "Owner's First Name",
                  required: ""
                }, null, 8, ["modelValue"]))
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_v_field, {
          class: "col-span-1",
          disabled: application.value.ownerIsSameAsSubmitter
        }, {
          default: _withCtx(() => [
            (!application.value.ownerIsSameAsSubmitter)
              ? (_openBlock(), _createBlock(_component_v_input, {
                  key: 0,
                  modelValue: application.value.ownerNameLast,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((application.value.ownerNameLast) = $event)),
                  "aria-label": "Owner's Last Name",
                  placeholder: "Owner's Last Name",
                  required: ""
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(_component_v_input, {
                  key: 1,
                  modelValue: application.value.creatorNameLast,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((application.value.creatorNameLast) = $event)),
                  "aria-label": "Owner's Last Name",
                  placeholder: "Owner's Last Name",
                  required: ""
                }, null, 8, ["modelValue"]))
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_v_switch_field, { class: "col-span-1 !flex !items-center !gap-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_switch, {
              modelValue: application.value.isEnterOwnerAddressManually,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((application.value.isEnterOwnerAddressManually) = $event)),
              color: "amber",
              "aria-label": "Enter address manually",
              name: "enter_address_manually"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_label, null, {
              default: _withCtx(() => [
                _createTextVNode("Enter address manually")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_8,
        (!application.value.isEnterOwnerAddressManually)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_google_maps_autocomplete, {
                modelValue: googleOwnerMailAddress.value,
                "onUpdate:modelValue": [
                  _cache[11] || (_cache[11] = ($event: any) => ((googleOwnerMailAddress).value = $event)),
                  _cache[12] || (_cache[12] = (value) => setOwnerMailingAddress(value))
                ],
                "input-id": "owner-mailing-address-search"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.ownerMailAddressSearchString,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((application.value.ownerMailAddressSearchString) = $event)),
                    id: "owner-mailing-address-search",
                    "aria-label": "Mailing Address",
                    autocomplete: "off",
                    placeholder: "Mailing Address",
                    required: "",
                    onBlur: _cache[14] || (_cache[14] = ($event: any) => (exitAddressSearch('owner')))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_description, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Type to search for mailing address ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.ownerMailAddress,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((application.value.ownerMailAddress) = $event)),
                    "aria-label": "Mailing Address",
                    placeholder: "Mailing Address",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.ownerMailAddress2,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((application.value.ownerMailAddress2) = $event)),
                    "aria-label": "Mailing Address 2",
                    placeholder: "Mailing Address 2"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.ownerMailCity,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((application.value.ownerMailCity) = $event)),
                    "aria-label": "City",
                    placeholder: "City",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.ownerMailState,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((application.value.ownerMailState) = $event)),
                    "aria-label": "State",
                    placeholder: "State",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.ownerMailZip,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((application.value.ownerMailZip) = $event)),
                    "aria-label": "ZIP",
                    placeholder: "ZIP",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])),
        _hoisted_11,
        _createVNode(_component_v_field, { class: "col-span-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_input, {
              modelValue: application.value.ownerTelephone,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((application.value.ownerTelephone) = $event)),
              "aria-label": "Telephone",
              placeholder: "Telephone",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_field, {
          class: "col-span-1",
          disabled: application.value.ownerIsSameAsSubmitter
        }, {
          default: _withCtx(() => [
            (!application.value.ownerIsSameAsSubmitter)
              ? (_openBlock(), _createBlock(_component_v_input, {
                  key: 0,
                  modelValue: application.value.ownerEmail,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((application.value.ownerEmail) = $event)),
                  "aria-label": "Email",
                  placeholder: "Email",
                  required: ""
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(_component_v_input, {
                  key: 1,
                  modelValue: application.value.creatorEmail,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((application.value.creatorEmail) = $event)),
                  "aria-label": "Email",
                  placeholder: "Email",
                  required: ""
                }, null, 8, ["modelValue"]))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_tw_select, {
          ref_key: "municipalityListbox",
          ref: municipalityListbox,
          id: "municipality",
          label: "Municipality",
          placeholder: "Municipality",
          required: "",
          class: "required",
          "hide-label": "",
          clearable: "",
          modelValue: application.value.municipality,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((application.value.municipality) = $event)),
          options: municipalityList.value
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_v_switch_field, { class: "col-span-1 lg:col-span-2 !flex !items-center !gap-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_switch, {
              modelValue: application.value.isEnterProjectAddressManually,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((application.value.isEnterProjectAddressManually) = $event)),
              color: "amber",
              "aria-label": "Enter address manually",
              name: "enter_project_address_manually"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_label, null, {
              default: _withCtx(() => [
                _createTextVNode("Enter address manually")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!application.value.isEnterProjectAddressManually)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_google_maps_autocomplete, {
                modelValue: googleProjectSiteAddress.value,
                "onUpdate:modelValue": [
                  _cache[25] || (_cache[25] = ($event: any) => ((googleProjectSiteAddress).value = $event)),
                  _cache[26] || (_cache[26] = (value) => setSiteMailingAddress(value))
                ],
                "input-id": "site-address-search"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.siteMailAddressSearchString,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((application.value.siteMailAddressSearchString) = $event)),
                    id: "site-address-search",
                    "aria-label": "Project Location",
                    autocomplete: "off",
                    placeholder: "Project Location",
                    required: "",
                    onBlur: _cache[28] || (_cache[28] = ($event: any) => (exitAddressSearch('site')))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_description, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Type to search for project address ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.siteMailAddress,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((application.value.siteMailAddress) = $event)),
                    "aria-label": "Site Address",
                    placeholder: "Site Address",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.siteMailAddress2,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((application.value.siteMailAddress2) = $event)),
                    "aria-label": "Site Address 2",
                    placeholder: "Site Address 2"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.siteMailCity,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((application.value.siteMailCity) = $event)),
                    "aria-label": "City",
                    placeholder: "City",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.siteMailState,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((application.value.siteMailState) = $event)),
                    "aria-label": "State",
                    placeholder: "State",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.siteMailZip,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((application.value.siteMailZip) = $event)),
                    "aria-label": "ZIP",
                    placeholder: "ZIP",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_v_field, { class: "col-span-1 lg:col-span-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_input, {
              modelValue: application.value.description,
              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((application.value.description) = $event)),
              "aria-label": "Project Description",
              placeholder: "Project Description",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_tw_select, {
          ref_key: "permitsRequestedListbox",
          ref: permitsRequestedListbox,
          id: "select-permits-required",
          label: "Select Permit(s) Requested",
          placeholder: "Select Permit(s) Requested",
          required: "",
          class: "required",
          "hide-label": "",
          multiple: "",
          clearable: "",
          "validation-error": "This field is required.",
          modelValue: application.value.permitType,
          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((application.value.permitType) = $event)),
          options: permitRequestedTypeList.value
        }, null, 8, ["modelValue", "options"]),
        (_unref(permitSubTypeList).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(permitSubTypeList), (item) => {
                return (_openBlock(), _createBlock(_component_tw_select, {
                  key: item.title,
                  label: item.title,
                  id: 'select-'+ item.title + '-sub-permits',
                  placeholder: 'Select ' + item.title + ' Sub Permit(s)',
                  class: "flex-none",
                  "hide-label": "",
                  required: "",
                  multiple: "",
                  clearable: "",
                  modelValue: permitRequestedSubPermits.value[item.field],
                  "onUpdate:modelValue": [
                    ($event: any) => ((permitRequestedSubPermits.value[item.field]) = $event),
                    _cache[36] || (_cache[36] = ($event: any) => (updateSelectedContractors()))
                  ],
                  options: item.options
                }, null, 8, ["label", "id", "placeholder", "modelValue", "onUpdate:modelValue", "options"]))
              }), 128)),
              (_unref(permitSubTypeContainsOther))
                ? (_openBlock(), _createBlock(_component_v_field, {
                    key: 0,
                    class: "col-span-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: permitRequestedOtherSubOptions.value,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((permitRequestedOtherSubOptions).value = $event)),
                        "aria-label": "Other Permit Sub Permits",
                        placeholder: "Other Sub Permit(s)"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_field, { class: "col-span-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_input, {
            modelValue: application.value.buildingCost,
            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((application.value.buildingCost) = $event)),
            "aria-label": "Estimated Cost of Project",
            placeholder: "Estimated Cost of Project",
            type: "number",
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            (!(application.value.contractorDwelling || application.value.contractorDwellingIsOwner))
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  onSubmit: _cache[41] || (_cache[41] = _withModifiers(($event: any) => (contractorSearch('general' , application.value.contractorDwellingSearchString)), ["prevent"])),
                  class: "flex items-center justify-start gap-2 mb-2"
                }, [
                  _createVNode(_component_v_field, { class: "w-full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MagnifyingGlassIcon)),
                          _createVNode(_component_v_input, {
                            modelValue: application.value.contractorDwellingSearchString,
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((application.value.contractorDwellingSearchString) = $event)),
                            "aria-label": "Search Dwelling Contractor",
                            name: "dwelling-contractor-search",
                            placeholder: "Enter in license number or name"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_button, {
                    "aria-label": "Search Dwelling Contractor Button",
                    color: "amber",
                    disabled: !application.value.contractorDwellingSearchString,
                    onClick: _cache[40] || (_cache[40] = ($event: any) => (contractorSearch('general' , application.value.contractorDwellingSearchString)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MagnifyingGlassIcon)),
                      _createTextVNode(" Search ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 32))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("p", _hoisted_31, _toDisplayString(application.value.contractorDwellingIsOwner ? 'Owner' : application.value.contractorDwelling?.name), 1),
                      (!application.value.contractorDwellingIsOwner)
                        ? (_openBlock(), _createBlock(contractorPopover, {
                            key: 0,
                            contractor: application.value.contractorDwelling ?? {}
                          }, null, 8, ["contractor"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_32, " License #: " + _toDisplayString(application.value?.contractorDwelling?.license ?? "(No License #)") + " • Exp: " + _toDisplayString(application.value?.contractorDwelling?.licenseExpirationDate ?? "(No Exp)"), 1)
                  ]),
                  _createVNode(_component_v_button, {
                    "aria-label": "Clear Dwelling Contractor Button",
                    color: "white",
                    onClick: _cache[42] || (_cache[42] = ($event: any) => (clearContractor('general')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Clear ")
                    ]),
                    _: 1
                  })
                ])),
            _createVNode(_component_v_checkbox_field, {
              class: "mt-2 sm:mt-0",
              disabled: application.value.contractorDwelling && !application.value.contractorDwellingIsOwner
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_checkbox, {
                  modelValue: application.value.contractorDwellingIsOwner,
                  "onUpdate:modelValue": [
                    _cache[43] || (_cache[43] = ($event: any) => ((application.value.contractorDwellingIsOwner) = $event)),
                    _cache[44] || (_cache[44] = (value) => setIsOwnerContractor('dwelling', value))
                  ],
                  color: "amber"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("I am performing the renovations myself")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            _withDirectives(_createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              (!(application.value.contractorDwellingQualifier || application.value.contractorDwellingQualifierIsOwner))
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    onSubmit: _cache[47] || (_cache[47] = _withModifiers(($event: any) => (contractorSearch('qualifier' , application.value.contractorDwellingQualifierSearchString)), ["prevent"])),
                    class: "flex items-end justify-start gap-2 mb-2"
                  }, [
                    _createVNode(_component_v_field, { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_input_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(MagnifyingGlassIcon)),
                            _createVNode(_component_v_input, {
                              modelValue: application.value.contractorDwellingQualifierSearchString,
                              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((application.value.contractorDwellingQualifierSearchString) = $event)),
                              "aria-label": "Search Dwelling Qualifier Contractor",
                              placeholder: "Enter in license number or name"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_button, {
                      "aria-label": "Search Dwelling Qualifier Contractor Button",
                      color: "amber",
                      disabled: !application.value.contractorDwellingQualifierSearchString,
                      onClick: _cache[46] || (_cache[46] = ($event: any) => (contractorSearch('qualifier' , application.value.contractorDwellingQualifierSearchString)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(MagnifyingGlassIcon)),
                        _createTextVNode(" Search ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ], 32))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("p", _hoisted_38, _toDisplayString(application.value.contractorDwellingQualifierIsOwner ? 'Owner' : application.value.contractorDwellingQualifier?.name), 1),
                        (!application.value.contractorDwellingQualifierIsOwner)
                          ? (_openBlock(), _createBlock(contractorPopover, {
                              key: 0,
                              contractor: application.value.contractorDwellingQualifier ?? {}
                            }, null, 8, ["contractor"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_39, " License #: " + _toDisplayString(application.value?.contractorDwellingQualifier?.license ?? "(No License #)") + " • Exp: " + _toDisplayString(application.value?.contractorDwellingQualifier?.licenseExpirationDate ?? "(No Exp)"), 1)
                    ]),
                    _createVNode(_component_v_button, {
                      "aria-label": "Clear Dwelling Qualifier Contractor Button",
                      color: "white",
                      onClick: _cache[48] || (_cache[48] = ($event: any) => (clearContractor('qualifier')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Clear ")
                      ]),
                      _: 1
                    })
                  ]))
            ], 512), [
              [_vShow, application.value.contractorDwelling || application.value.contractorDwellingIsOwner]
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            (!(application.value.contractorElectrical || application.value.contractorElectricalIsOwner))
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  onSubmit: _cache[51] || (_cache[51] = _withModifiers(($event: any) => (contractorSearch('electrical' , application.value.contractorElectricalSearchString)), ["prevent"])),
                  class: "flex items-end justify-start gap-2 mb-2"
                }, [
                  _createVNode(_component_v_field, { class: "w-full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MagnifyingGlassIcon)),
                          _createVNode(_component_v_input, {
                            modelValue: application.value.contractorElectricalSearchString,
                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((application.value.contractorElectricalSearchString) = $event)),
                            "aria-label": "Search Electrical Contractor",
                            placeholder: "Enter in license number or name"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_button, {
                    "aria-label": "Search Electrical Contractor Button",
                    color: "amber",
                    disabled: !application.value.contractorElectricalSearchString,
                    onClick: _cache[50] || (_cache[50] = ($event: any) => (contractorSearch('electrical' , application.value.contractorElectricalSearchString)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MagnifyingGlassIcon)),
                      _createTextVNode(" Search ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 32))
              : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("p", _hoisted_45, _toDisplayString(application.value.contractorElectricalIsOwner ? 'Owner' : application.value.contractorElectrical?.name), 1),
                      (!application.value.contractorElectricalIsOwner)
                        ? (_openBlock(), _createBlock(contractorPopover, {
                            key: 0,
                            contractor: application.value.contractorElectrical ?? {}
                          }, null, 8, ["contractor"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_46, " License #: " + _toDisplayString(application.value?.contractorElectrical?.license ?? "(No License #)") + " • Exp: " + _toDisplayString(application.value?.contractorElectrical?.licenseExpirationDate ?? "(No Exp)"), 1)
                  ]),
                  _createVNode(_component_v_button, {
                    "aria-label": "Clear Electrical Contractor Button",
                    color: "white",
                    onClick: _cache[52] || (_cache[52] = ($event: any) => (clearContractor('electrical')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Clear ")
                    ]),
                    _: 1
                  })
                ])),
            _createVNode(_component_v_checkbox_field, {
              class: "mt-2 sm:mt-0",
              disabled: (application.value.contractorElectrical && !application.value.contractorElectricalIsOwner) || _unref(isOwnerDisabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_checkbox, {
                  modelValue: application.value.contractorElectricalIsOwner,
                  "onUpdate:modelValue": [
                    _cache[53] || (_cache[53] = ($event: any) => ((application.value.contractorElectricalIsOwner) = $event)),
                    _cache[54] || (_cache[54] = (value) => setIsOwnerContractor('electrical', value))
                  ],
                  color: "amber"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("I am performing the renovations myself")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            _withDirectives(_createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              (!(application.value.contractorElectricalMaster || application.value.contractorElectricalMasterIsOwner))
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    onSubmit: _cache[57] || (_cache[57] = _withModifiers(($event: any) => (contractorSearch('masterElectrician' , application.value.contractorElectricalMasterSearchString)), ["prevent"])),
                    class: "flex items-end justify-start gap-2 mb-2"
                  }, [
                    _createVNode(_component_v_field, { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_input_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(MagnifyingGlassIcon)),
                            _createVNode(_component_v_input, {
                              modelValue: application.value.contractorElectricalMasterSearchString,
                              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((application.value.contractorElectricalMasterSearchString) = $event)),
                              "aria-label": "Search Master Electrical Contractor",
                              placeholder: "Enter in license number or name"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_button, {
                      "aria-label": "Search Master Electrical Contractor Button",
                      color: "amber",
                      disabled: !application.value.contractorElectricalMasterSearchString,
                      onClick: _cache[56] || (_cache[56] = ($event: any) => (contractorSearch('masterElectrician' , application.value.contractorElectricalMasterSearchString)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(MagnifyingGlassIcon)),
                        _createTextVNode(" Search ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ], 32))
                : ((application.value.contractorElectricalMaster || application.value.contractorElectricalMasterIsOwner) && (application.value.contractorElectrical || application.value.contractorElectricalIsOwner))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("p", _hoisted_52, _toDisplayString(application.value.contractorElectricalMasterIsOwner ? 'Owner' : application.value.contractorElectricalMaster?.name), 1),
                          (!application.value.contractorElectricalMasterIsOwner)
                            ? (_openBlock(), _createBlock(contractorPopover, {
                                key: 0,
                                contractor: application.value.contractorElectricalMaster ?? {}
                              }, null, 8, ["contractor"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_53, " License #: " + _toDisplayString(application.value?.contractorElectricalMaster?.license ?? "(No License #)") + " • Exp: " + _toDisplayString(application.value?.contractorElectricalMaster?.licenseExpirationDate ?? "(No Exp)"), 1)
                      ]),
                      _createVNode(_component_v_button, {
                        "aria-label": "Clear Master Electrical Contractor Button",
                        color: "white",
                        onClick: _cache[58] || (_cache[58] = ($event: any) => (clearContractor('masterElectrician')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Clear ")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
              (application.value.contractorElectrical || application.value.contractorElectricalIsOwner)
                ? (_openBlock(), _createBlock(_component_v_checkbox_field, {
                    key: 2,
                    class: "mt-2 sm:mt-0",
                    disabled: (application.value.contractorElectricalMaster && !application.value.contractorElectricalMasterIsOwner) || _unref(isOwnerDisabled)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_checkbox, {
                        modelValue: application.value.contractorElectricalMasterIsOwner,
                        "onUpdate:modelValue": [
                          _cache[59] || (_cache[59] = ($event: any) => ((application.value.contractorElectricalMasterIsOwner) = $event)),
                          _cache[60] || (_cache[60] = (value) => setIsOwnerContractor('masterElectrician', value))
                        ],
                        color: "amber"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode("I am performing the renovations myself")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, application.value.contractorElectrical || application.value.contractorElectricalIsOwner]
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            (!(application.value.contractorHVAC || application.value.contractorHVACIsOwner))
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  onSubmit: _cache[63] || (_cache[63] = _withModifiers(($event: any) => (contractorSearch('hvac' , application.value.contractorHVACSearchString)), ["prevent"])),
                  class: "flex items-center justify-start gap-2 mb-2"
                }, [
                  _createVNode(_component_v_field, { class: "w-full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MagnifyingGlassIcon)),
                          _createVNode(_component_v_input, {
                            modelValue: application.value.contractorHVACSearchString,
                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((application.value.contractorHVACSearchString) = $event)),
                            "aria-label": "Search HVAC Contractor",
                            placeholder: "Enter in license number or name"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_button, {
                    "aria-label": "Search HVAC Contractor Button",
                    color: "amber",
                    disabled: !application.value.contractorHVACSearchString,
                    onClick: _cache[62] || (_cache[62] = ($event: any) => (contractorSearch('hvac' , application.value.contractorHVACSearchString)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MagnifyingGlassIcon)),
                      _createTextVNode(" Search ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 32))
              : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("p", _hoisted_59, _toDisplayString(application.value.contractorHVACIsOwner ? 'Owner' : application.value.contractorHVAC?.name), 1),
                      (!application.value.contractorHVACIsOwner)
                        ? (_openBlock(), _createBlock(contractorPopover, {
                            key: 0,
                            contractor: application.value.contractorHVAC ?? {}
                          }, null, 8, ["contractor"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_60, " License #: " + _toDisplayString(application.value?.contractorHVAC?.license ?? "(No License #)") + " • Exp: " + _toDisplayString(application.value?.contractorHVAC?.licenseExpirationDate ?? "(No Exp)"), 1)
                  ]),
                  _createVNode(_component_v_button, {
                    "aria-label": "Clear HVAC Contractor Button",
                    color: "white",
                    onClick: _cache[64] || (_cache[64] = ($event: any) => (clearContractor('hvac')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Clear ")
                    ]),
                    _: 1
                  })
                ])),
            _createVNode(_component_v_checkbox_field, {
              class: "mt-2 sm:mt-0",
              disabled: (application.value.contractorHVAC && !application.value.contractorHVACIsOwner) || _unref(isOwnerDisabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_checkbox, {
                  modelValue: application.value.contractorHVACIsOwner,
                  "onUpdate:modelValue": [
                    _cache[65] || (_cache[65] = ($event: any) => ((application.value.contractorHVACIsOwner) = $event)),
                    _cache[66] || (_cache[66] = (value) => setIsOwnerContractor('hvac', value))
                  ],
                  color: "amber"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("I am performing the renovations myself")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            (!(application.value.contractorPlumbing || application.value.contractorPlumbingIsOwner))
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  onSubmit: _cache[69] || (_cache[69] = _withModifiers(($event: any) => (contractorSearch('plumbing' , application.value.contractorPlumbingSearchString)), ["prevent"])),
                  class: "flex items-center justify-start gap-2 mb-2"
                }, [
                  _createVNode(_component_v_field, { class: "w-full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MagnifyingGlassIcon)),
                          _createVNode(_component_v_input, {
                            modelValue: application.value.contractorPlumbingSearchString,
                            "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((application.value.contractorPlumbingSearchString) = $event)),
                            "aria-label": "Search Plumbing Contractor",
                            placeholder: "Enter in license number or name"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_button, {
                    "aria-label": "Search Plumbing Contractor Button",
                    color: "amber",
                    disabled: !application.value.contractorPlumbingSearchString,
                    onClick: _cache[68] || (_cache[68] = ($event: any) => (contractorSearch('plumbing' , application.value.contractorPlumbingSearchString)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MagnifyingGlassIcon)),
                      _createTextVNode(" Search ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 32))
              : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("p", _hoisted_66, _toDisplayString(application.value.contractorPlumbingIsOwner ? 'Owner' : application.value.contractorPlumbing?.name), 1),
                      (!application.value.contractorPlumbingIsOwner)
                        ? (_openBlock(), _createBlock(contractorPopover, {
                            key: 0,
                            contractor: application.value.contractorPlumbing ?? {}
                          }, null, 8, ["contractor"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_67, " License #: " + _toDisplayString(application.value?.contractorPlumbing?.license ?? "(No License #)") + " • Exp: " + _toDisplayString(application.value?.contractorPlumbing?.licenseExpirationDate ?? "(No Exp)"), 1)
                  ]),
                  _createVNode(_component_v_button, {
                    "aria-label": "Clear Plumbing Contractor Button",
                    color: "white",
                    onClick: _cache[70] || (_cache[70] = ($event: any) => (clearContractor('plumbing')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Clear ")
                    ]),
                    _: 1
                  })
                ])),
            _createVNode(_component_v_checkbox_field, {
              class: "mt-2 sm:mt-0",
              disabled: (application.value.contractorPlumbing && !application.value.contractorPlumbingIsOwner) || _unref(isOwnerDisabled)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_checkbox, {
                  modelValue: application.value.contractorPlumbingIsOwner,
                  "onUpdate:modelValue": [
                    _cache[71] || (_cache[71] = ($event: any) => ((application.value.contractorPlumbingIsOwner) = $event)),
                    _cache[72] || (_cache[72] = (value) => setIsOwnerContractor('plumbing', value))
                  ],
                  color: "amber"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("I am performing the renovations myself")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          (contractorLoading.value !== null && contractorSearchType.value !== null)
            ? (_openBlock(), _createBlock(_component_tw_table, {
                key: 0,
                class: "flex w-full col-span-2",
                loading: contractorLoading.value,
                title: contractorSearchTitle.value + ' Contractor Search Results',
                data: contractorSearchResults.value ?? [],
                "page-length": 9,
                placeholder: contractorMissingText.value,
                ref_key: "contractorTable",
                ref: contractorTable
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_tw_table_column, {
                    header: "Contractor",
                    prop: "name",
                    "class-name": "w-40",
                    "header-class-name": "w-40"
                  }),
                  _createVNode(_component_tw_table_column, {
                    header: "License",
                    prop: "license",
                    "class-name": "w-40",
                    "header-class-name": "w-40"
                  }, {
                    default: _withCtx(({row}) => [
                      _createElementVNode("div", null, _toDisplayString(row.license) + " • " + _toDisplayString(row.licenseExpirationDate), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_tw_table_column, {
                    header: "Select contractor",
                    "class-name": "text-right px-0",
                    "header-class-name": "sr-only"
                  }, {
                    default: _withCtx(({row}) => [
                      _createVNode(_component_v_button, {
                        color: "white",
                        plain: "",
                        size: "sm",
                        onClick: ($event: any) => (selectContractor(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Select ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "title", "data", "placeholder"]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_69, [
            _createVNode(_component_v_button, {
              color: "amber",
              onClick: openModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Add New Contractor ")
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, !contractorSearchResults.value.length && contractorLoading.value !== null && contractorLoading.value !== true && contractorSearchType.value !== null]
          ])
        ])
      ]),
      _createVNode(_component_v_switch_field, { class: "col-span-1 lg:col-span-2 !flex !items-center !gap-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_switch, {
            modelValue: application.value.isShowAllApplicationFields,
            "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((application.value.isShowAllApplicationFields) = $event)),
            color: "amber",
            "aria-label": "Show all application fields",
            name: "show_all_application_fields"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_label, null, {
            default: _withCtx(() => [
              _createTextVNode("Show all application fields")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (application.value.isShowAllApplicationFields)
        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.siteSubdivision,
                    "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((application.value.siteSubdivision) = $event)),
                    "aria-label": "Subdivision",
                    placeholder: "Subdivision",
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "required"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.siteLotNumber,
                    "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((application.value.siteLotNumber) = $event)),
                    "aria-label": "Lot Number",
                    placeholder: "Lot Number",
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "required"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.siteBlockNumber,
                    "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((application.value.siteBlockNumber) = $event)),
                    "aria-label": "Block Number",
                    placeholder: "Block Number",
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "required"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.zoningDistrict,
                    "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((application.value.zoningDistrict) = $event)),
                    "aria-label": "Zoning District(s)",
                    placeholder: "Zoning District(s)",
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "required"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input, {
                    modelValue: application.value.zoningPermitNumber,
                    "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((application.value.zoningPermitNumber) = $event)),
                    "aria-label": "Zoning Permit Number",
                    placeholder: "Zoning Permit Number",
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "required"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.lotArea,
                        "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((application.value.lotArea) = $event)),
                        type: "number",
                        "aria-label": "Lot Area",
                        placeholder: "Lot Area",
                        required: _unref(isNewConstruction)
                      }, null, 8, ["modelValue", "required"]),
                      _hoisted_72
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_checkbox_field, { class: "col-span-1 lg:col-span-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: application.value.isAcreSoilDisturbed,
                    "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((application.value.isAcreSoilDisturbed) = $event)),
                    color: "amber"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode("One acre or more of soil will be disturbed")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.setBackFront,
                        "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((application.value.setBackFront) = $event)),
                        type: "number",
                        "aria-label": "Set Backs Front",
                        placeholder: "Front",
                        required: _unref(isNewConstruction)
                      }, null, 8, ["modelValue", "required"]),
                      _hoisted_75
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.setBackRear,
                        "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((application.value.setBackRear) = $event)),
                        type: "number",
                        "aria-label": "Set Backs Rear",
                        placeholder: "Rear",
                        required: _unref(isNewConstruction)
                      }, null, 8, ["modelValue", "required"]),
                      _hoisted_76
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.setBackLeft,
                        "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((application.value.setBackLeft) = $event)),
                        type: "number",
                        "aria-label": "Set Backs Left",
                        placeholder: "Left",
                        required: _unref(isNewConstruction)
                      }, null, 8, ["modelValue", "required"]),
                      _hoisted_77
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_input_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.setBackRight,
                        "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((application.value.setBackRight) = $event)),
                        type: "number",
                        "aria-label": "Set Backs Right",
                        placeholder: "Right",
                        required: _unref(isNewConstruction)
                      }, null, 8, ["modelValue", "required"]),
                      _hoisted_78
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              _createVNode(_component_tw_select, {
                id: "project-type",
                label: "Project Type",
                placeholder: "Project Type",
                clearable: "",
                "hide-label": "",
                modelValue: application.value.projectType,
                "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((application.value.projectType) = $event)),
                options: projectTypeList.value,
                required: _unref(isNewConstruction)
              }, null, 8, ["modelValue", "options", "required"])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createElementVNode("div", _hoisted_83, [
                _createVNode(_component_v_field, { class: "col-span-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_input_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_input, {
                          modelValue: application.value.areaBasement,
                          "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((application.value.areaBasement) = $event)),
                          type: "number",
                          "aria-label": "Area Involved Basement",
                          placeholder: "Basement",
                          required: _unref(isNewConstruction)
                        }, null, 8, ["modelValue", "required"]),
                        _hoisted_84
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_field, { class: "col-span-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_input_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_input, {
                          modelValue: application.value.areaLiving,
                          "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((application.value.areaLiving) = $event)),
                          type: "number",
                          "aria-label": "Area Involved Living Area",
                          placeholder: "Living Area",
                          required: _unref(isNewConstruction)
                        }, null, 8, ["modelValue", "required"]),
                        _hoisted_85
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_field, { class: "col-span-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_input_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_input, {
                          modelValue: application.value.areaGarage,
                          "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((application.value.areaGarage) = $event)),
                          type: "number",
                          "aria-label": "Area Involved Garage",
                          placeholder: "Garage",
                          required: _unref(isNewConstruction)
                        }, null, 8, ["modelValue", "required"]),
                        _hoisted_86
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_field, { class: "col-span-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_input_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_input, {
                          modelValue: application.value.areaOther,
                          "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((application.value.areaOther) = $event)),
                          type: "number",
                          "aria-label": "Area Involved Other",
                          placeholder: "Other",
                          required: _unref(isNewConstruction)
                        }, null, 8, ["modelValue", "required"]),
                        _hoisted_87
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createVNode(_component_tw_select, {
                    class: "col-span-1",
                    id: "occupancy",
                    label: "Occupancy",
                    placeholder: "Occupancy",
                    clearable: "",
                    "hide-label": "",
                    modelValue: application.value.occupancy,
                    "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((application.value.occupancy) = $event)),
                    options: occupancyTypeList.value,
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "options", "required"]),
                  _withDirectives(_createVNode(_component_v_field, { class: "col-span-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.occupancyOther,
                        "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((application.value.occupancyOther) = $event)),
                        "aria-label": "Occupancy Other Description",
                        placeholder: "Occupancy Other Description"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, application.value.occupancy == 'Other:']
                  ])
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createVNode(_component_tw_select, {
                    id: "construction-type",
                    label: "Construction Type",
                    placeholder: "Construction Type",
                    clearable: "",
                    "hide-label": "",
                    modelValue: application.value.constructionType,
                    "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((application.value.constructionType) = $event)),
                    options: constructionTypeList.value,
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "options", "required"])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createVNode(_component_tw_select, {
                    id: "story",
                    label: "Stories",
                    placeholder: "Stories",
                    clearable: "",
                    "hide-label": "",
                    modelValue: application.value.story,
                    "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((application.value.story) = $event)),
                    options: storyTypeList.value,
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "options", "required"]),
                  _withDirectives(_createVNode(_component_v_field, { class: "col-span-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.storyOther,
                        "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((application.value.storyOther) = $event)),
                        "aria-label": "Stories Other Description",
                        placeholder: "Stories Other Description"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, application.value.story == 'Other:']
                  ])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createVNode(_component_v_field, { class: "col-span-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_input, {
                            modelValue: application.value.electricalAmps,
                            "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((application.value.electricalAmps) = $event)),
                            type: "number",
                            "aria-label": "Electrical Entrance Panel",
                            placeholder: "Electrical Entrance Panel",
                            required: _unref(isNewConstruction)
                          }, null, 8, ["modelValue", "required"]),
                          _hoisted_93
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createVNode(_component_tw_select, {
                    id: "electric-service",
                    label: "Electric Service",
                    placeholder: "Electric Service",
                    clearable: "",
                    "hide-label": "",
                    modelValue: application.value.electricService,
                    "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((application.value.electricService) = $event)),
                    options: electricServiceTypeList.value,
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "options", "required"])
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _createVNode(_component_tw_select, {
                    id: "electric-utility",
                    label: "Electric Utility",
                    placeholder: "Electric Utility",
                    clearable: "",
                    "hide-label": "",
                    modelValue: application.value.electricUtility,
                    "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((application.value.electricUtility) = $event)),
                    options: electricUtilityTypeList.value,
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "options", "required"])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _createVNode(_component_tw_select, {
                    id: "wall",
                    label: "Walls",
                    placeholder: "Walls",
                    clearable: "",
                    "hide-label": "",
                    modelValue: application.value.wall,
                    "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((application.value.wall) = $event)),
                    options: wallTypeList.value,
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "options", "required"]),
                  _withDirectives(_createVNode(_component_v_field, { class: "col-span-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.wallOther,
                        "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((application.value.wallOther) = $event)),
                        "aria-label": "Walls Other Description",
                        placeholder: "Walls Other Description"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, application.value.wall == 'Other:']
                  ])
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _createVNode(_component_tw_select, {
                    id: "use",
                    label: "Use",
                    placeholder: "Use",
                    clearable: "",
                    "hide-label": "",
                    modelValue: application.value.use,
                    "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((application.value.use) = $event)),
                    options: useTypeList.value,
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "options", "required"]),
                  _withDirectives(_createVNode(_component_v_field, { class: "col-span-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.useOther,
                        "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((application.value.useOther) = $event)),
                        "aria-label": "Use Other Description",
                        placeholder: "Use Other Description"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, application.value.use == 'Other:']
                  ])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createVNode(_component_tw_select, {
                    class: "col-span-1",
                    id: "hvac-equipment",
                    label: "HVAC Equipment",
                    placeholder: "HVAC Equipment",
                    "hide-label": "",
                    clearable: "",
                    multiple: "",
                    modelValue: application.value.hvacs,
                    "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((application.value.hvacs) = $event)),
                    options: HVACEquipmentList.value,
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "options", "required"]),
                  _withDirectives(_createVNode(_component_v_field, { class: "col-span-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.hvacsOther,
                        "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((application.value.hvacsOther) = $event)),
                        "aria-label": "HVAC Equipment Other",
                        placeholder: "HVAC Equipment Other"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, application.value.hvacs.toString().includes('Other')]
                  ])
                ]),
                _createElementVNode("div", _hoisted_99, [
                  _createVNode(_component_tw_select, {
                    id: "sewer",
                    label: "Sewer",
                    placeholder: "Sewer",
                    clearable: "",
                    "hide-label": "",
                    modelValue: application.value.sewer,
                    "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => ((application.value.sewer) = $event)),
                    options: sewerTypeList.value,
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "options", "required"]),
                  _withDirectives(_createVNode(_component_v_field, { class: "col-span-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_input, {
                        modelValue: application.value.sewerSanitaryPermitNo,
                        "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => ((application.value.sewerSanitaryPermitNo) = $event)),
                        "aria-label": "Sanitary Permit Number",
                        placeholder: "Sanitary Permit Number"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, application.value.sewer == 'Sanitary']
                  ])
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _createVNode(_component_tw_select, {
                    id: "water",
                    label: "Water",
                    placeholder: "Water",
                    clearable: "",
                    "hide-label": "",
                    modelValue: application.value.water ,
                    "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => ((application.value.water ) = $event)),
                    options:  waterTypeList.value,
                    required: _unref(isNewConstruction)
                  }, null, 8, ["modelValue", "options", "required"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_101, [
              _hoisted_102,
              _createElementVNode("div", _hoisted_103, [
                _createVNode(_component_tw_select, {
                  id: "space-heating",
                  label: "Space Heating",
                  placeholder: "Space Heating",
                  clearable: "",
                  "hide-label": "",
                  modelValue: application.value.energySpace,
                  "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((application.value.energySpace) = $event)),
                  options: energySpaceTypeList.value,
                  required: _unref(isNewConstruction)
                }, null, 8, ["modelValue", "options", "required"]),
                _withDirectives(_createVNode(_component_v_field, { class: "col-span-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_input, {
                      modelValue: application.value.energySpaceOther,
                      "onUpdate:modelValue": _cache[108] || (_cache[108] = ($event: any) => ((application.value.energySpaceOther) = $event)),
                      "aria-label": "Space Heating Other Description",
                      placeholder: "Space Heating Other Description"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, application.value.energySpace == 'Other:']
                ])
              ]),
              _createElementVNode("div", _hoisted_104, [
                _createVNode(_component_tw_select, {
                  id: "water-heating",
                  label: "Water Heating",
                  placeholder: "Water Heating",
                  clearable: "",
                  "hide-label": "",
                  modelValue: application.value.energyWater,
                  "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((application.value.energyWater) = $event)),
                  options:  waterHeatingTypeList.value,
                  required: _unref(isNewConstruction)
                }, null, 8, ["modelValue", "options", "required"]),
                _withDirectives(_createVNode(_component_v_field, { class: "col-span-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_input, {
                      modelValue: application.value.energyWaterOther,
                      "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => ((application.value.energyWaterOther) = $event)),
                      "aria-label": "Water Heating Other Description",
                      placeholder: "Water Heating Other Description"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, application.value.energyWater == 'Other:']
                ])
              ]),
              _createElementVNode("div", _hoisted_105, [
                _createVNode(_component_v_field, { class: "col-span-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_input, {
                      modelValue: application.value.heatLostBTU,
                      "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => ((application.value.heatLostBTU) = $event)),
                      "aria-label": "Heat Lost (BTU/HR Total)",
                      placeholder: "Heat Lost (BTU/HR Total)",
                      required: _unref(isNewConstruction)
                    }, null, 8, ["modelValue", "required"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_106, [
        _hoisted_107,
        _hoisted_108,
        _createVNode(_component_tw_table, {
          class: "col-span-1 mx-4",
          loading: fileUploadingLoading.value,
          data: application.value.files ?? [],
          placeholder: "No Files Uploaded"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: "Filename",
              prop: "fileName",
              "class-name": "w-1/2 overflow-truncate py-2",
              "header-class-name": "w-1/2"
            }),
            _createVNode(_component_tw_table_column, {
              header: "Uploaded At",
              prop: "created",
              "class-name": "w-3/10 overflow-truncate py-2",
              "header-class-name": "w-3/10"
            }),
            _createVNode(_component_tw_table_column, {
              header: "File options",
              "class-name": "px-0 py-2 text-right",
              "header-class-name": "sr-only",
              align: "right"
            }, {
              default: _withCtx(({row}) => [
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_v_button, {
                    plain: "",
                    onClick: ($event: any) => (downloadFile(row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CloudArrowDownIcon))
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (row.isAllowedDelete)
                    ? (_openBlock(), _createBlock(_component_v_button, {
                        key: 0,
                        plain: "",
                        onClick: ($event: any) => (openDeleteModal(row))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TrashIcon))
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, (file.value) && !((fileDownloadLoading.value.length > application.value.files.indexOf(row)) && (fileDownloadLoading.value[application.value.files.indexOf(row)]))]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_tw_loading)
                ], 512), [
                  [_vShow, (file.value) && (fileDownloadLoading.value.length > application.value.files.indexOf(row)) && (fileDownloadLoading.value[application.value.files.indexOf(row)])]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "data"]),
        _createElementVNode("div", _hoisted_109, [
          _createElementVNode("div", {
            class: "stealthFileContainer fileContainer w-full",
            ref_key: "drop",
            ref: drop,
            onDragover: _cache[113] || (_cache[113] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _cache[114] || (_cache[114] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("label", {
              for: "FileUpload",
              class: _normalizeClass([{'border-solid' : !file.value, 'border-dashed' : file.value}, "w-auto flex-none fileContainer relative border-2 border-gray-300 rounded-sm text-center hover:border-gray-400 cursor-pointer box-content flex justify-start align-middle"])
            }, [
              _createElementVNode("div", _hoisted_110, [
                _createVNode(_unref(DocumentArrowUpIcon), {
                  "aria-hidden": "true",
                  class: "mx-auto h-6 w-6 text-gray-500"
                }),
                _hoisted_111
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["h-full w-full absolute top-0 left-0 text-white text-3xl p-8", {'bg-gray-400 opacity-100 bg-opacity-90 rounded-sm z-20': isOver.value, 'z-0  opacity-0 ': !isOver.value}])
              }, " Drop to upload file ", 2),
              _createElementVNode("input", {
                type: "file",
                id: "FileUpload",
                name: "upload",
                accept: ".jpg, .gif, .png, .pdf",
                onChange: _cache[112] || (_cache[112] = ($event: any) => (fileUpload($event))),
                class: "hidden h-44 w-44",
                ref_key: "documentUploadRef",
                ref: documentUploadRef
              }, null, 544)
            ], 2)
          ], 544)
        ])
      ]),
      _createElementVNode("div", _hoisted_112, [
        _hoisted_113,
        _hoisted_114,
        _hoisted_115,
        _createElementVNode("div", _hoisted_116, [
          _createVNode(_component_v_button, {
            color: "white",
            class: "w-full",
            disabled: !application.value.signatureComplete || application.value.signaturePad?.isEmpty(),
            onClick: clearSignature
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Clear Signature ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_117, [
        _hoisted_118,
        _createElementVNode("div", _hoisted_121, [
          _createVNode(_component_router_link, {
            to: {name: 'LandingPage'},
            class: "w-full sm:w-24"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_button, {
                class: "w-full sm:w-24",
                color: "white",
                plain: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!application.value?.id)
            ? (_openBlock(), _createBlock(_component_v_button, {
                key: 0,
                class: "w-full sm:w-48",
                color: "white",
                outline: "",
                loading: submitting.value,
                disabled: submitting.value,
                onClick: _cache[115] || (_cache[115] = ($event: any) => (saveForLater()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Save As Draft ")
                ]),
                _: 1
              }, 8, ["loading", "disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_button, {
            class: "w-full sm:w-48",
            color: "amber",
            loading: submitting.value,
            disabled: submitting.value,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Submit Application ")
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ])
    ], 40, _hoisted_2),
    _createElementVNode("div", _hoisted_122, [
      _createVNode(_component_tw_modal, {
        ref_key: "contractorModal",
        ref: contractorModal,
        title: 'New ' + addingContractor.value.type + ' Contractor',
        "modal-max-width": "max-w-md"
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            id: "add-contractor-form",
            onSubmit: _withModifiers(addContractor, ["prevent"]),
            class: "mt-4"
          }, [
            _createElementVNode("div", _hoisted_124, [
              _createVNode(_component_v_input, {
                modelValue: addingContractor.value.company,
                "onUpdate:modelValue": _cache[116] || (_cache[116] = ($event: any) => ((addingContractor.value.company) = $event)),
                "aria-label": "New Contractor Company",
                placeholder: "Contractor Company",
                required: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_input, {
                modelValue: addingContractor.value.license,
                "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((addingContractor.value.license) = $event)),
                "aria-label": "New Contractor License Number",
                placeholder: "License Number",
                required: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_input, {
                modelValue: addingContractor.value.expiration,
                "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => ((addingContractor.value.expiration) = $event)),
                "aria-label": "New Contractor License Expiration Date",
                placeholder: "Expiration Date",
                required: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_input, {
                modelValue: addingContractor.value.nameFirst,
                "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => ((addingContractor.value.nameFirst) = $event)),
                "aria-label": "New Contractor First Name",
                placeholder: "Contractor First Name",
                required: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_input, {
                modelValue: addingContractor.value.nameLast,
                "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event: any) => ((addingContractor.value.nameLast) = $event)),
                "aria-label": "New Contractor Last Name",
                placeholder: "Contractor Last Name",
                required: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_input, {
                modelValue: addingContractor.value.phone,
                "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event: any) => ((addingContractor.value.phone) = $event)),
                "aria-label": "New Contractor Phone Number",
                type: "tel",
                placeholder: "Contractor Phone Number",
                required: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_input, {
                modelValue: addingContractor.value.email,
                "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event: any) => ((addingContractor.value.email) = $event)),
                "aria-label": "New Contractor Email",
                type: "email",
                placeholder: "Contractor Email",
                required: ""
              }, null, 8, ["modelValue"]),
              (addingContractorErrorMessage.value)
                ? (_openBlock(), _createBlock(_component_v_error_message, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(addingContractorErrorMessage.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_125, [
              _createVNode(_component_v_button, {
                class: "capitalize w-full",
                color: "amber",
                onClick: addContractor
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Add New " + _toDisplayString(contractorSearchType.value) + " Contractor ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_button, {
                class: "capitalize w-full",
                color: "white",
                onClick: clearAddContractorValues
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ]),
                _: 1
              })
            ])
          ], 40, _hoisted_123)
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _createVNode(_component_tw_modal, {
      title: "Delete File",
      "modal-max-width": "max-w-lg",
      ref_key: "deleteModal",
      ref: deleteModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_126, [
          _createElementVNode("p", null, "Permantly delete " + _toDisplayString(selectedFile.value.fileName) + "? There is no undoing this action.", 1)
        ]),
        _createElementVNode("div", _hoisted_127, [
          _createVNode(_component_v_button, {
            disabled: deleteLoading.value,
            loading: deleteLoading.value,
            class: "w-full sm:w-56",
            color: "white",
            onClick: _cache[123] || (_cache[123] = ($event: any) => (closeDeleteModal(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_v_button, {
            disabled: deleteLoading.value,
            loading: deleteLoading.value,
            class: "w-full sm:w-56",
            color: "amber",
            onClick: _cache[124] || (_cache[124] = ($event: any) => (closeDeleteModal(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Delete ")
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})